module.exports = {
  "+1Wujb": "{num} элементаў",
  "+4lD9e": "Імя",
  "+L9lak": "Ужыць шаблон трывогі",
  "+bRanp": "Калі ласка, увядзіце максімальную колькасць апавяшчэнняў",
  "+d7aNN": "Спіс шаблонаў трывог",
  "/COTHZ": "Імя модуля сігналізацыі не можа быць пустым",
  "/cqdKk": "Спампаваць",
  "/l9tS2": "Не запускаецца",
  "/sI6h+": "Я",
  "z9+Z7p": "Выбраць тэгі",
  "03eM6t": "200 элементаў/старонку",
  "0JCY6+": "Разгортванне",
  "0sn8j/": "Калі ласка, увядзіце сваё імя",
  "1UXyeT": "Час запуску",
  "1WymPU": "Выберыце значэнне трыгера будзільніка",
  "2+X2n8": "Пакетнае выдаленне",
  "28oE7E": "Прылада не выбрана",
  "29A4OA": "Удзельнік кампаніі",
  "2QzYmY": "Адмена",
  P76mDe: "Синхронное управление файлами",
  pGioLb: "Последовательность устройства SN",
  "wnPTP+": "Введите серийный номер устройства",
  i5Nyva: "Непрочитано",
  ich0wH: "серийный номер устройства",
  wpKIvP: "Читать",
  wDqNy1: "Пример",
  "5ЭЙНИу": "Поиск оборудования по компаниям",
  "2rDc7R": "Правілы будзільнікаў не могуць быць пустымі",
  "2t0Cct": "Дата разгортвання",
  "32AbcK": "Выберыце кампанію",
  "36+mbi": "Стан апрацоўкі",
  "3HzQUc": "Экспарт JSON",
  "3RVwfq": "Калі ласка, дадайце каментарыі",
  "3aYG4L":
    "Выдаліць шаблон будзільніка, які зараз прымяняецца да прылады, і больш не кантраляваць і адпраўляць сігналы трывогі",
  "3qVnoZ": "Колькасць прылад ({num})",
  "4/e9qs": "Калі ласка, увядзіце імя",
  "4VVrWd":
    "Вы ўпэўненыя, што адключыце ({name}) шаблон сігналізацыі? Пасля яго адключэння новыя прылады сігналізацыі не змогуць прымяніць шаблон.",
  "4vWL+W": "Імпартаваць прыладу",
  "4wi+/p": "Шаблон",
  "5SSVAQ": "Новы шаблон будзільніка",
  "5grmob": "Калі ласка, увядзіце свой адрас электроннай пошты",
  "5p8cBO": "Кіраванне ўліковым запісам",
  "60Ixlm": "Назва шаблону трывогі",
  "6ABIlp": "Статус трыгера",
  "6mjOF/": "Пакетны скід",
  "7G1c4h": "Спіс прылад",
  "8PESa6": "Адключыць",
  "919TK9": "Падтрымліваюцца фарматы: xls, xlsx",
  "9Kfib+": "Невядомая памылка",
  "9UefLp": "этыкетка",
  B57Wbu: "Прылада не выбрана",
  BC74I9: "Аператыўнае паведамленне",
  BQcLxf: "Перасунуцца ўніз",
  BYbqwY: "Перацягніце файл сюды або націсніце, каб загрузіць",
  BhkglP: "Праглядзець маркер",
  BwXapw: "Калі ласка, кантралюйце назву катэгорыі ў межах 500 знакаў",
  CLqPBU: "Рэдагаваць",
  D3lDHK: "Дадаць правіла трывогі",
  D5HOUz: "Выбраць статус",
  E2kRYi: "Пакетнае ўключэнне",
  "EZ+vMa": "Анатацыя шаблону",
  EwM8Kj: "Вы ўпэўнены, што хочаце з'ехаць?",
  Ey9rBq: "Вы ўпэўнены, што хочаце выдаліць яго?",
  F2LJDJ: "Вы ўпэўнены, што хочаце выдаліць?",
  F56ZKt: "Выбраць удзельнікаў",
  FEb7U2: "Пацвердзіць",
  "FaJ/jI": "Не выбраны файл для імпарту",
  FbCeo1: "Значэнне трыгера",
  FbsCUK: "Мабільны тэлефон",
  FeJVkL: "Дадаць дадатковых атрымальнікаў",
  "Fr1I/b": "этыкетка",
  "G+BH4o": "Вы ўпэўнены, што хочаце выдаліць бягучую прыладу ({name})?",
  GKSW97: "Пакетнае адключэнне",
  GQ5EVQ: "Адзначце хаця б адзін",
  GUMdjP: "Стан апошняга выканання",
  Gk0Mt5:
    "Вы ўпэўненыя, што скінулі ({name}) прыладу сігналізацыі? Пасля скіду правілы сігналізацыі будуць працягвацца.",
  GujK99:
    "Калі змесціва шаблону трывогі будзе абноўлена пазней, яно таксама будзе сінхранізавана з ужывальнай прыладай",
  HN1dNJ: "Усе ўліковыя запісы",
  IqkgWZ: "Ключавое слова",
  "Iwt/8W": "Анатацыя",
  "J0D5h+": "Час пачатку",
  J9jPRL: "Капіраванне паспяхова",
  JJl2M9: "Экспарт",
  JeJAmT: "Перайменаваць",
  Jh62y5: "Усе прылады",
  Jp7u8z: "Я",
  LWSLHa: "Цёплы напамін",
  Ls1X2Z: "Апрацавана",
  "LuP+H0": "Апісанне",
  LwhdsE: "Пераключыць некалькі выбараў",
  MnTdIi: "Колькасць трыгераў",
  MvGPdx:
    "Вы ўпэўненыя, што ўключылі ({name}) шаблон будзільніка? Пасля яго ўключэння новыя прылады сігналізацыі змогуць прымяніць шаблон.",
  N4np50: "Максімальная колькасць апавяшчэнняў",
  NTanl8: "Дадаць шаблон будзільніка",
  NW8FV4: "Стан каманды прылады",
  OsMncl: "Не ўключаны",
  "P/eul9": "Не",
  P6YSaZ: "Гісторыя трывог",
  PgNsL5: "Разгортванне",
  "Py/5UG": "Апераваны вузел больш не існуе, апрацуйце яшчэ раз",
  "Q2/NzC": "Выбрана {num} прылад",
  QHhMxE: "Выберыце сімвал",
  QV3pnn: "Стан",
  "QavrS/": "Назва правіла",
  QwHI8Q: "Вынікі запыту:",
  R2D5Dv: "Час стварэння",
  R3TTCW: "Рэдагаваць шаблон будзільніка",
  S57QRB: "Фільтраваць па",
  SGDlQ6: "Усяго {total} элементаў",
  T3CtvK: "Назва катэгорыі не можа быць пустой",
  TDuPUp: "Спрацаваў",
  TqDOFU: "Калі ласка, не дасылайце коды спраўджання часта!",
  U2DqqT: "Пошук кампаніі",
  UBbWUL: "Ніякі шаблон не выбраны",
  UFjZVV: "Статус разгортвання",
  UUtqvk: "Неапрацаваны",
  UcumBq: "Апавяшчэнне пра трывогу",
  UtE0dS: "Аперацыя",
  "Uu/nFu": "Выдаліць усе шаблоны будзільнікаў, прымененыя да гэтай прылады",
  V0RiZp: "Аперацыя паспяховая",
  VR6zMp: "Вы ўпэўнены, што хочаце адключыць яго?",
  VRizgn: "Калі ласка, увядзіце нумар свайго мабільнага тэлефона",
  ViVQNi: "роля",
  WeKYMe: "Час апошняга заказу",
  Wp6QLH:
    "Вы пацвярджаеце скід ({name}) правіла сігналізацыі? Пасля скіду правіла сігналізацыі будзе працягвацца.",
  "WwRq+y": "Калі ласка, дадайце аб'ект апавяшчэння трывогі",
  "X/cNgA": "Выдаліць напамін",
  XFEq9J: "Статус шаблону",
  XG2wHz: "Разгортванне паспяхова",
  XMBOec: "Выдаліць тэг",
  XeiAal: "Выдаліць",
  XgmTAk: "Сэрыйны нумар прылады",
  YBAsWB: "Каманда групы",
  YpXN8m: "Час апошняга запуску",
  ZETl7o: "Шаблон будзільніка",
  ZMUuo8: "Вы ўпэўненыя, што хочаце ўключыць гэта?",
  ZPSpaL: "Імя модуля сігналізацыі",
  ZUPzqr: "Уключыць",
  "Zvt+2g": "Склад",
  aBleoN: "Абярыце шаблон будзільніка",
  "aN+DgN": "Час актывацыі",
  aiBGBs: "Выдаліць пасьпяхова",
  "arp+TQ": "50 элементаў/старонку",
  "bE+h3K": "Стан прылады",
  bOKDVF: "Пераключыць выбар радыё",
  bqbDVw: "Запыт",
  cDZ00w: "Прагляд",
  drCsUI: "Кампанія",
  e8OyHO: "20 элементаў/старонку",
  f7Dpbl:
    "Спампуйце шаблон і палепшыце змест у адпаведнасці з падказкамі шаблона",
  fz2pkM: "Гэты вузел быў выдалены",
  gU4eZD: "Кіраванне сігналізацыяй",
  ggvI6Z: "Выбраць усё",
  gomg5W: "Адключыць напамін",
  gzHM5l: "Дата выпуску будзільніка",
  "hDx3/S": "Электронная пошта",
  hMboy7: "Падрабязнасці стану каманды",
  iKomBu: "Пакуль няма класіфікацыі",
  ieTzi7: "Падрабязнасці шаблона трывогі",
  ifGp4v: "2FA",
  iyOrrD: "100 элементаў/старонку",
  j6IHvr: "Паглядзець дэталі",
  jT6zKT: "Колькасць прылад",
  jdbKm7: "Аб'ект абвесткі пра трывогу",
  jddlWH: "Збой разгортвання",
  kCh5Jz: "падказка",
  kG2Etz: "У сетцы",
  khyRcw: "Калі ласка, абярыце файл Excel",
  kwOS33: "Уключыць напамін",
  l1fZNE: "Немагчыма зняць усе галачкі",
  loTFGc: "Без назвы",
  m0Qdyj: "Памылка праверкі",
  ma6S6y: "Індывідуальны дысплей",
  "mpeFt+": "Правілы сігналізацыі",
  nH1F3p: "Вы ўпэўнены, што выдаліце ​​бягучае правіла будзільніка ({name})?",
  nJCPaY:
    "Карыстальнік не мае прывязанага адраса электроннай пошты і не можа быць правераны",
  nUSeQB: "Уліковы запіс не выбраны",
  nw8orn: "Колькасьць апавешчаных",
  pBPyFt: "Вэрсія Nubis",
  "pV2t/S": "Асноўная інфармацыя",
  pcU9bM: "Дадаць удзельніка",
  q6qKtH: "Умова запыту:",
  qUKj7E: "Капіяваць",
  "r0/TUu": "ОК",
  "r2dEd/": "Скінуць",
  s9U9qn: "Паставіць будзільнік",
  sOIerB: "Не актывавана",
  sZSyGZ: "Уключыць",
  srEpKw: "Загрузка",
  srpWCM:
    "Праверце палі, якія трэба адлюстраваць, і перацягніце іх для сартаваньня",
  t2iHNJ: "Абнавіць",
  "tCh+iz": "Час спрацоўвання будзільніка",
  tLW3W3: "Нумар мабільнага тэлефона",
  tokMPz: "Аб'ект выключэння",
  "uoZwj+": "Стваральнік",
  v04auv: "Час заканчэння",
  w8L9Kj: "Наладзіць правілы сігналізацыі",
  wOHHSJ: "Перасунуцца ўверх",
  wQAiLI: "Скінуць напамін",
  xISm1t: "актываваць",
  xUjLTE: "Пошук",
  y9NWzQ: "Спіс прылад сігналізацыі",
  yGWx2z: "Памылка параметру",
  yOMNOj: "Так",
  yReEcE: "Выбраць тэг",
  yXsHgv: "10 элементаў/старонку",
  yb3AuG: "па-за сеткай",
  ybGQQ3: "Няма адпаведных вынікаў",
  "yiO/gL": "Спіс шаблонаў",
  yxPDHk: "Статус выпуску",
  zH7h1q: "Гісторыя",
  "96Mzoq": "Завершана",
  ByhhM1: "Умова",
  PcCooF: "Значэнне сігналізацыі",
  RUMaeu: "Правілы будзільніка запоўніце цалкам",
  h7w4pz: "Пакуль няма дадзеных",
  nMMNa6: "Мы паведамім вам праз электронную пошту, SMS або сістэму.",
  "nOE0/j": "Пошук кампаній і ўдзельнікаў",
  q6WPYA:
    "Выбраная прылада змяшчае {num} версій Nubis Free, і групавая адпраўка каманд будзе немагчымая.",
  "+CP3nr": "Абярыце задачу",
  "+gbx50": "Умова трывогі",
  "+wet4N": "Памылка праверачнага кода",
  "/BzHXM": "Выберыце стваральніка",
  "/SqqyP": "Увядзіце серыйны нумар прылады",
  "0YYUNG": "Было выбрана {num} тэгаў",
  "1M03Dq": "Шаблон раскладу",
  "1SslIM": "Закрыць прыкладанне",
  "1gjtU2": "Час апошняга выканання",
  "1sj5Sj": "Выдаліць усе шаблоны раскладаў, прымененыя да гэтай прылады",
  "2MYr1m": "Уваход",
  "2l+gFk":
    "Вы ўпэўнены, што ўключылі ({name}) шаблон раскладу? Пасля яго ўключэння прылада можа спасылацца на шаблон.",
  "2opnVU": "Падчас выканання",
  "2r/XUW": "Выдаліць усе шаблоны раскладаў, прымененыя гэтым тэгам",
  "3xlnbE": "Час каманды",
  "47GdDb": "Зачыніць",
  "5ytYaf": "Новы шаблон раскладу",
  "65DvZ1": "Верхняя мяжа ўводу: 4",
  "6x6nu5": "Фактычны час выканання",
  "8zN+hZ": "Выканаць прыкладанне",
  "9UZxwP": "Калі ласка, увядзіце праверачны код",
  "9kkcTB": "Выдаліць шаблон раскладу",
  "9ljNkr": "Адправіць",
  "A/eXwT": "Выдаліць усе шаблоны трывог, прымененыя да гэтай меткі",
  AyWMlZ: "Дадаць запланаванае заданне",
  BiPxfI: "Дадаць шаблон раскладу",
  C6cGK1: "Назва шаблону планавання не можа быць пустой",
  EGvInA: "Спіс трывог абсталявання",
  Ft60hS: "Прылада Nubis",
  Gwj7xc: "Аднавіць стандартнае",
  H15ECl: "Прыкладанне ўводу",
  "J3BW/8":
    "Калі ласка, увядзіце код спраўджання, які вы атрымалі па электроннай пошце",
  KW8qOm: "Абярыце шаблон",
  LADN1a: "Статус выканання раскладу",
  Lfia0v: "Усталяваць расклад",
  NDmD8V: "Вы ўпэўнены, што хочаце выдаліць шаблон раскладу ({name})?",
  OVecAI: "Поспех",
  OwtOn5: "Агульны стан",
  PTc6Gt: "Уключыць расклад",
  PaMvre: "Спіс правілаў будзільнікаў",
  PnYplH: "Абсталяванне",
  RNaGVr: "Спіс памылак задач",
  RWBRyt: "Карта размяшчэння абсталявання ў стадыі распрацоўкі",
  "RuFFf/":
    "Вы ўпэўнены, што адключыце ({name}) шаблон раскладу? Пасля адключэння прылада не можа спасылацца на шаблон.",
  SPyEF8: "Выбраць рэжым",
  SwMBFl: "Ужыць шаблон раскладу",
  TDSTTj: "Абярыце шаблон раскладу",
  UMU42c: "Выберыце прыладу",
  Unvxiq: "Пераключыць уліковы запіс",
  WxPZOH: "Выканаць {num} разоў",
  WypzMq: "Запланаваныя заданні",
  X2m4ec: "Адключыць шаблон раскладу",
  "YIgP+p": "Спіс раскладу прылад",
  LNGTru: "Спіс памылак планавання прылады",
  YwEzx2: "Праверце палі, якія трэба паказаць",
  Z2B362: "Бесьперапынны",
  ZBDct6: "Збой: {num}",
  ZHAjhZ: "Верхняя мяжа ўводу: 30",
  Zr9Dss: "Збой",
  azDNha: "Адпраўлена паспяхова",
  b5l2vN: "Захаваць",
  b6y8Ai: "Вы ўпэўнены, што адключыце ({name}) расклад?",
  bYIKFB: "Выконваецца: {num}",
  "e/6XZC": "Не атрымалі код спраўджання?",
  eAgY2G: "Пашырыць даччыныя кампаніі",
  fl7J8Y: "Паведамленне",
  "gH+Az7": "Адключыць расклад",
  gi4oTZ: "Спіс шаблонаў планавання",
  gplM71: "Штодня",
  "hAd+eG": "Каляндар раскладу абсталявання",
  "hD7/Lu": "Дысплей",
  hYN7oM: "Схаваць",
  hfn1Ux: "Поспех/Усяго",
  hkJXyi: "Наладзіць запланаваныя задачы",
  "hkR3E+": "Рэжым прагляду",
  hwlmeB: "Тып мэты",
  iN7Lps: "Рэжым цыкла",
  iscUWH: "Завершана: {num}",
  "j/YGZ0": "карта",
  j6Hm96: "Запланаванае выкананне",
  jNxbTC: "Код спраўджання не можа быць пустым",
  js3tZs: "Назва шаблону планавання",
  k9dozc: "Час выканання",
  kUagYW: "Гісторыя выканання раскладу",
  l7IiCY: "Статус раскладу",
  "lzP/we": "спампаваць ORA",
  m1h20o:
    "Калі змесціва наступнага шаблону раскладу абнаўляецца, яно таксама будзе сінхранізавана з ужывальнай прыладай",
  "mC2//O": "Праглядзець каляндар раскладу",
  mFIXSq: "Сэрыйны нумар прылады",
  mISQTh: "Падрабязнасці",
  nGubXb: "Падрабязнасці шаблона планавання",
  nqPJwo: "для тэгаў",
  oCogiy: "каманда",
  oY0m24: "карыстальнік",
  oirnwv: "Уключыць шаблон раскладу",
  ojz0Ke: "Паглядзець больш >",
  oru5FY: "Рэдагаваць шаблон раскладу",
  "p+zOzc": "вынік",
  peNVzr: "Кожныя {num} тыдняў",
  pfGGi0:
    "Выдаліць шаблон раскладу, які зараз прымяняецца да прылады, і больш не выконваць яго",
  pielKO: "Загрузная прылада",
  pkYJKs: "Статус выканання",
  qhC4wy: "Пошук прылады",
  rUHCoM: "Планаванне абсталявання",
  sb1vdX: "Выконваецца",
  u3dVQz: "Штотыдзень",
  "urr92/": "Выберыце праграму разгортвання",
  vovKL8: "Шлях праграмы не можа быць пустым",
  "wrU/Kc": "Кожныя {num} дзён",
  ygAHaf: "Час адпраўкі",
  zvaxmN: "Кіраванне раскладам",
  "2ffDGT":
    "Вы ўпэўненыя, што закрыеце запланаванае заданне? Прылада не будзе выконваць шаблон раскладу пасля закрыцця.",
  "D//rZg": "Вы ўпэўненыя, што выдаліце ​​прымяненне шаблону раскладу?",
  E1GPl7: "Уладальнік",
  EwTMGn: "Вы ўпэўнены, што ўключыце ({name}) расклад?",
  GpzsBd: "Адкрыць запланаваныя задачы",
  IM8kXz: "Вы ўпэўнены, што хочаце выдаліць прыкладанне ({name})?",
  KXqGQe: "Пакетная актывацыя",
  NGe0Cs: "Выдаліць запісы выканання раскладу",
  SkK50H: "Калі ласка, дадайце запланаванае заданне",
  Trt6ju:
    "Вы ўпэўнены, што запусціце запланаванае заданне? Пасля запуску прылада павінна выканаць запланаванае заданне.",
  UiVtQS: "Пакет зачынены",
  "Z56D+X": "Закрыць запланаваныя задачы",
  aKxrop: "Выдаліць прымяненне шаблону раскладу",
  miANEg:
    "Вы ўпэўненыя, што хочаце закрыць ({name}) запланаванае заданне? Прылада не будзе выконваць запланаванае заданне пасля закрыцця.",
  ngLF8L: "Вы ўпэўнены, што хочаце выдаліць запіс выканання раскладу ({name})?",
  nqPOJc:
    "Вы ўпэўненыя, што хочаце адкрыць ({name}) запланаванае заданне? Пасля адкрыцця прылада павінна выканаць запланаванае заданне.",
  oV0gpL: "Запланаваная дата выпуску",
  xtHJEE: "Запісы не выбраны",
  yifWnc: "Вы ўпэўнены, што хочаце выдаліць запіс выканання раскладу?",
  "+/R6RX": "Стан задачы",
  "35v5wD": "Вы ўпэўнены, што скінуць гісторыю будзільнікаў?",
  "3QXG/d": "Версія Ora",
  "5jpkHg": "Анлайнавы стан",
  G4XFn6: "Мадэль абсталявання",
  Ko5CPO: "Вы ўпэўнены, што скінуць гісторыю будзільнікаў?",
  ajVpLe: "Вы ўпэўнены, што жадаеце выдаліць гэту гісторыю будзільнікаў?",
  dEXfrL: "Інтэрвал спраўнасці прылады",
  eCCa0L: "Тып задачы",
  fr4nkj: "Вы ўпэўнены, што жадаеце выдаліць гісторыю будзільнікаў?",
  nzsNwZ: "Стан здароўя прылады",
  qDba8m: "Стан прылады ў аўтаномным рэжыме",
  rDRAr0: "Версія аперацыйнай сістэмы",
  YeF1dY: "Часавы пояс",
  BC52ne: "Ігнаруецца",
  SbZhau: "У задачы загрузкі неабходна ўказаць загрузачную прыладу",
  "lsLYU/": "Максімальная колькасць апавяшчэнняў не можа перавышаць 10",
  "NM/lRq": "Скасаваць загрузку",
  "3qF993":
    "Вы не можаце перадаць прылады, якія не ўваходзяць у вашу бягучую кампанію.",
  "6+iYA0": "серыйны нумар",
  yc6ZUL: "Ora Стан апошняга абнаўлення",
  UA7mv6: "Ora Час апошняга абнаўленьня",
  "fOwU1/": "належыць",
  jNiwk6: "Вы ўпэўнены, што хочаце выдаліць сігналізацыю ({name})?",
  "lLa/D3": "Ужыць тып",
  "wk1c/l":
    "У адпаведнасці з перыядам часу абнаўлення адценняў шэрага прылады (мясцовы час)",
  "5+oaTO": "статус апошняга абнаўлення выявы",
  "6pDRb2": "Калі ласка, увядзіце сапраўдны пароль",
  ANeFu6: "Праверыць пароль",
  GnzEo7: "час апошняга абнаўлення выявы",
  s7NSze:
    "Калі ласка, увядзіце пароль свайго ўліковага запісу перад пацвярджэннем аперацыі",
  "9RNrDU": "Ці з'яўляецца гэта проксі-прыладай",
  "+TzicH": "Гандляр",
  "/CxA3j": "Дадаць субгандляра",
  "4c3uw8": "Выдаліць гандляра",
  "5Hy0Qx": "Немагчыма перадаць таму ж гандляру",
  BBpRbn: "Выдаліць усе шаблоны трывог, якія прымяняюцца гэтым гандляром",
  DADacD: "Выдаліць усе шаблоны раскладаў, якія прымяняюцца гэтым гандляром",
  G9WbnV: "Для гандляроў",
  S1QSWC: "Імпартны субгандляр",
  TYAJpp: "Было выбрана {num} гандляроў",
  Ve9Ksw: "Перадача гандляра",
  Wzv7kF: "Калі ласка, абярыце гандляра",
  h7Yvwt: "Міжгандляр",
  jAAXdQ: "Гандляр рыштунку",
  "kr+7Iy": "Пошук гандляроў",
  tFr3tb:
    "Вы ўпэўненыя, што хочаце выдаліць шаблон трывогі ({name})? Пасля выдалення прымяненне гэтага шаблону прыладай, гандляром і этыкеткай будзе адначасова скасавана.",
  uuRzdk: "Атрыбутавана гандляру",
  vD5wnY:
    "Праверка прыналежнасці гандляра азначае, што ў вас ёсць дазвол гандляра",
  zyMKgy: "Выберыце гандляра",
  RndUeh: "Прыблізны час выканання",
  gcHeN9:
    "Калі ласка, увядзіце назву праграмы АС. Напрыклад: Windows:chrome або Android:com.android.chrome",
  EM8lAi:
    "У адпаведнасці з перыядам часу, даступным для абнаўлення прылады (мясцовы час)",
  "4Regzm": "Спіс гандляроў",
  "i6kDf/":
    "Выбранное устройство содержит {num} версий Nubis Free, и команды устройства будут невозможны.",
  o8tJYm: "Команда устройства",
  "+74JfZ": "Пример: Device_000001_Gaoqiao Merchant_Android",
  "+CLSks":
    "2. Тип системы устройства, к которому применяется это правило именования",
  "+GQdfc": "Обновить токен",
  "+m8vFq": "Подробности правила именования",
  "0KH9Qi": "Тип системы устройства",
  "0Z908D": "Вы можете выбрать только одну версию одного и того же приложения",
  "0bBO2n": "версия",
  "0iTEVO": "Просмотреть токен",
  "12LEcf": "Вы уверены, что отключите ({name}) это правило именования?",
  "1PtjRr": "Имя устройства",
  "2/LdaO": "Сохранить информацию о конфигурации",
  "2V19bd": "Сведения о файле конфигурации",
  "2jlHQB": "2. Правила именования компании по умолчанию",
  "3JwoQQ": "Загрузка не удалась, и приложение не может ее проанализировать.",
  "3ZtPM3":
    "Если в магазине не установлены правила именования, при добавлении новых устройств будут применяться правила именования компании. Если вы не хотите применять их, вы можете отключить следующие правила",
  "3qgucc": "Установить часовой пояс вручную",
  "5FboZ/": "Тип",
  "5ZgUEM": "Редактировать шаблон конфигурации",
  "5d3yZi": "Эффективное время",
  "5noX9X": "Имя файла конфигурации",
  "6Ty5/G": "Опубликовано успешно",
  "7NmXNy": "Информация о текущей программе",
  "7PkBL6": "Включить автоматические обновления",
  "7ip592": "1. Имя правила именования",
  "88CuCZ":
    "3. Создать метод именования для устройств, зарегистрированных в этом магазине (автоматически заполнять имена устройств)",
  "8WYGi+": "Вы уверены, что хотите скопировать?",
  "8huAxo": "Добавить новое правило",
  "8pB1C7": "Добавить приложение",
  "8u3CYe": "Имя правила именования",
  "8zQ4So": "Идентификатор пакета:",
  "96c3gX": "Формат",
  "9Fvzl9": "Пакетный выпуск",
  "9iKk2b": "Стартовый номер",
  AFZDo7: "История установки",
  B0WqD0: "1. Период обновления устройства (местное время)",
  BqUpjt: "Пожалуйста, введите имя пакета, например com.android.chrome",
  "CM76+/":
    "Вы уверены включить ({name}) этот шаблон? После его включения устройство сможет ссылаться на этот шаблон",
  CPTAAj: "Натуральное увеличение числа",
  CqlH6G: "Применить список магазинов",
  "D/Yid+": "Включить",
  D2KnIQ: "Связанное хранилище успешно успешно",
  DpnauN: "время",
  Fi4xFb: "Загрузить приложение Android успешно",
  G9APSK: "Изменить правила именования",
  GRfLaO: "Имя приложения",
  HDYjnT:
    "В настоящее время выбранная версия приложения ниже, чем существующее приложение, что может привести к сбою установки приложения. Пожалуйста, подтвердите, правильно ли выбрано приложение. Если вам нужно установить приложение с более низкой версией, вы можете проверить удалить исходную программу и затем установить ее.",
  HOHQFs: "Имя правила именования не может быть пустым",
  "HdxQ2/": "Файлы конфигурации, связанные с хранилищем, и правила именования",
  "I/k8FH": "Выпустить",
  IyhhzI: "Создать файл конфигурации",
  Kj5TRg: "Количество устанавливаемых устройств",
  "L4w/Vo": "Последняя версия",
  MI3yI1: "Загрузка {percentCompleted}%",
  MRe8Q9: "Номер версии:",
  NrEurQ: "Загрузка в Мбит/с",
  Nrx60r: "Загрузка в Мбит/с",
  OCp4OD: "Просмотреть файл конфигурации",
  OiP4rW:
    "В настоящее время существует файл конфигурации, связанный с магазином, проверьте.",
  PDFXBi: "Опубликовать сейчас",
  PkLYZS: "Правила именования устройств",
  PlNIQ9: "Системные настройки",
  "Q+0CDu": "Добавить правило именования",
  Q5vbU5: "Идентификаторы пакетов несовместимы",
  QpOtgZ: "Название магазина",
  R9TpN6: "Приблизительное время установки",
  RY4VVr: "Загрузчик",
  RyXQqJ: "Время загрузки",
  UfxykZ: "причина",
  Unr58u: "Время обновления",
  Uzdb6l: "Тип устройства:",
  Vd3wZV: "В целом",
  VqEr9u: "Применить количество магазинов",
  WdyIyo: "Время работы",
  WfS4rv: "Оператор:",
  "XLdI1+": "Сила Wi-Fi",
  XnimdQ: "Окна",
  Ym4SPE: "Выберите время выпуска (время выполнения устройства)",
  ZWN1C0: "Вы уверены включить ({name}) это правило именования?",
  ZdO12B: "Применить магазин",
  ZtZ7Yw: "Название программы",
  "a++4i0": "Время публикации должно быть позже 24 часов",
  aHlr3k: "Удалить",
  akvGrq: "Правила конфигурации",
  aqQg0p: "область",
  b95U3r: "Список файлов конфигурации",
  bMdSkq: "Запись теста скорости сети",
  batMBC: "Вы уверены, что хотите удалить шаблон ({name})?",
  bsjenW: "Включить правила именования",
  cX08hK: "Данные не выбраны",
  cawvIS: "Время последнего обновления",
  cijnrq: "Устройство установлено",
  d8xSfX: "код версии",
  dGBGbt: "Все",
  dRYBRc: "Номер версии: {version}",
  "devicesList@1": "Выбрать все устройства",
  "devicesList@2": "Выбрать все устройства",
  eUNh5K: "Устройство для установки",
  "ecTX+c": "Укажите название программы",
  eeCxuz: "Тип ОС",
  epaa3H: "Добавить правила именования",
  evJP5c: "Правила именования",
  fX0dsH: "Версия:",
  "fje/m/": "Имя шаблона:",
  fq3WGG: "Управление файлами конфигурации",
  gQ7kPU: "Андроид",
  gnNjS5: "Имя личного устройства",
  gyHdsW: "Шаблон конфигурации",
  "gyh+d1": "Кабельная сеть",
  hDmGQl: "Проверять ли код версии",
  hqGPDw: "Включить 24-часовой формат",
  hxy4wV: "Разбор",
  i5JzAA: "Статус:",
  i5MLJc: "Время последнего обновления: {lastUpdate}",
  ie9Iom: "Просмотреть шаблон конфигурации",
  ifAmoA: "Шаблон файла конфигурации",
  imhWD8: "Настройки загрузки",
  iroVTo: "Настройки компании",
  j2kqd8: "Удалить правила именования",
  j3QWSE:
    "Начальное число для приращения натурального числа может быть только положительным целым числом",
  "jN5tO+": "Код версии: {versionCode}",
  "jhfb/7": "Сохранение успешно",
  k7dy8j: "Связанный файл конфигурации",
  kH9MHe: "Отключить правила именования",
  kkLQie: "связанный магазин",
  "ksb/lB": "Удалять ли исходную программу",
  l0mW6t: "Время последнего обновления",
  mRHwkp:
    "Вы уверены, что отключили ({name}) шаблон? После его отключения устройство не сможет ссылаться на шаблон",
  "mYa6W/": "Пользовательский текст",
  "mml+gT": "Выбрать приложение",
  mn0ceu: "Есть повторяющиеся правила конфигурации, пожалуйста, измените",
  n1yIyi: "Время установки",
  nDwIwd: "Опубликовано",
  nJetAr: "Неподдерживаемый формат.",
  nLERtc: "Обновить приложение Android",
  o9bMHL: "размер",
  oC6GBl: "Приложение Android",
  "oFt+cN": "Тест скорости сети",
  ovdKZi: "Невозможно установить номер устройства",
  "p/3Nn5": "Мобильная сеть",
  qS0aFJ: "Управление приложениями",
  qUiH5y: "Правила конфигурации не могут быть пустыми",
  qjtl3b: "Включить обновления системы",
  "qqwM/t": "Файл конфигурации",
  rdEPl7: "Невозможно установить устройство",
  rsAvN6: "Название программы:",
  rw3uGa: "Новый шаблон конфигурации",
  "s+aIlP": "Поиск по названию магазина",
  saeFbf: "Файл",
  t8R6VW: "Идентификатор пакета: {package}",
  tWcCoB: "Дата проверки скорости",
  twpxdo: "Загрузить приложение Android",
  "u/NB+Y": "Идентификатор пакета",
  vDCwZ9: "Загрузить файл",
  vLW90z: "Вы уверены, что удалили правило именования ({name})?",
  vr5TVT: "Пожалуйста, введите",
  wiSRo9: "Количество установленных устройств",
  "xE1H+X": "Настройки",
  xdjVt1: "Имя шаблона не заполнено",
  xlNcvg: "Последнее обновление:",
  xrQzKh: "Пожалуйста, введите название приложения, например chrome",
  xwYDb8: "Код версии:",
  ydktLD: "разделитель",
  zeMk2K: "Черновик",
  zok1hp: "Слот C",
  zrIs7T: "Время последнего обновления",
  lPA1qT: "Эта конфигурация предназначена только для определенных устройств",
  oXfYag: "Код версии уже существует, пожалуйста, загрузите еще раз",
  "k+a7BC": "Выполнить автоматическое обновление",
  "/k2Fs5": "Правила именования конфигурации",
  e2ys3T: "Сохранить сведения о конфигурации",
  yy7EDI: "Выгрузка",
  "+cCXuw": "Выбрать изображение из файла",
  "0cZQXI": "Добавить по идентификатору пакета",
  "0xm1Zu": "Заблокировать комбинацию клавиш",
  "33bmiC": "Родительский каталог не существует",
  "4UcMA+": "Добавить Wi-Fi",
  "4ia8sI": "Управление функциями",
  "4o167y": "Длина пользовательского текста не может превышать 30",
  "66awCH": "Обновить",
  "C+cw77": "Конфигурация обоев",
  E6G3sr: "Режим киоска",
  "FQK+2G": "Синхронизация файлов",
  FWlWJR: "Просмотр информации о магазине",
  HI1PTY: "Введите путь к папке",
  HNavdr: "Название компании",
  JPIKnb: "Главный экран",
  MufYuw: "Экран блокировки",
  NPjnPZ: "Яркость",
  "Pdx/YD": "Пароль",
  Pg5mqb: "Пейзажный режим",
  QSjBm5: "Файл не существует",
  UH1kCc: "Добавить",
  UduVZX: "Выбрать файл",
  Usn1oq: "Портретный режим",
  "Ymq1/H": "Имя папки устройства",
  YzG9Iw: "Черный список",
  ZK1d6f: "SSID",
  bGGvOS: "Выбрать изображение",
  c8uKl6: "Wi-Fi",
  dZlNkV: "Добавить конфигурацию",
  dmEBpU: "Конфигурация синхронизации файлов",
  foT1aq: "Текущий прогресс загрузки:",
  g5Pknn: "Размер файла превышает лимит",
  gltp3e: "Отключить уведомления Windows",
  gweUAO: "Блокировать интерфейс USB",
  nxeBGd: "Пример:",
  o8HwKf: "Имя файла",
  rULuF3: "Разрешены ли только следующие сетевые подключения",
  tIm58E: "Стоп",
  tR69qg: "Язык отображения Windows",
  tnYpSo: "Запрос на обнаружение отправлен успешно",
  xNeD5U: "Отменено",
  xiwfUp: "Объем",
  znna6r: "Информация о магазине",
  "+UT6Us": "Зімбабве",
  "+cSl6d": "Нідерланди",
  "+vx0UI": "Соломонові Острови",
  "+vz4Gy": "Сьєрра-Леоне",
  "/1g/gd": "Кірібаті",
  "/EzG+0": "Монтсеррат",
  "/ZaEbq": "Гаїті",
  "07BMT/": "Алжир",
  "0E6+/f": "Гуам",
  "14axoc": "Фолклендські Острови",
  "1BFTBO": "Куба",
  "1GLoiG": "Грузія",
  "1Z3cpQ": "Кот-д'Івуар",
  "1qc1Bb": "Латвія",
  "217kis": "Руанда",
  "2c/STs": "Молдова",
  "3B2kCX": "Фарерські Острови",
  "3Nlsp9": "Словаччина",
  "3a17nf": "Острови Кука",
  "41lx/9": "Афганістан",
  "4KMP9f": "Конго",
  "4obEtL": "Того",
  "5w+tOJ": "Албанія",
  "62Z8c1": "Палау",
  "6JR/Y7": "Ірландія",
  "6LZPqX": "Самоа",
  "6Mnz8p": "Мавританія",
  "6NPwCy": "Сирія",
  "6f8kym": "Ірак",
  "6qdPnx": "Туніс",
  "7KZ6vz": "Венесуела",
  "7hGupC": "Литва",
  "7hNQVL": "Філіппіни",
  "7p85Tc": "Кюрасао",
  "8m5tda": "Єгипет",
  "8y7qAE": "Центральноафриканська Республіка",
  "98qFTO": "Джерсі",
  "99fbLn": "Уругвай",
  "9T1JPo": "Мальта",
  AD5RPE: "Екваторіальна Гвінея",
  AKnToQ: "Чад",
  "AO/9GT": "Фінляндія",
  AYs4yh: "Мадагаскар",
  Ai6HyC: "Уганда",
  AksTq6: "Антигуа і Барбуда",
  ArbweL: "Йорданія",
  AzRGCX: "Німеччина",
  "B/oRh5": "Федеративні Штати Мікронезії",
  BcJbbP: "Катар",
  Bm5GdP: "Тайвань",
  MRbe2A: "Тайвань",
  BwMY6I: "Західна Сахара",
  BxT2qw: "Токелау",
  C0YR5J: "Туркменістан",
  C2pikc: "Південний Судан",
  C7RUR5: "Науру",
  CKu8W1: "Ніуе",
  CYSGlA: "Естонія",
  "D/Hl19": "Мартиніка",
  DPthJ5: "Люксембург",
  Dxf50E: "Коморські Острови",
  EMaGPN: "Сомалі",
  "Eihfz+": "Пакистан",
  Eul4yJ: "Італія",
  F0BTvX: "Реюньйон",
  FsQ2Ph: "Північні Маріанські Острови",
  FzXhJn: "Ватикан",
  GRDGdf: "Нова Каледонія",
  "HF/NiY": "Вірменія",
  HN9EHr: "Південна Корея",
  HTqMY5: "Румунія",
  HZs8KL: "Буркіна-Фасо",
  I2RkrK: "Камбоджа",
  I7Erl3: "Марокко",
  IGBRed: "Азербайджан",
  IPfyBg: "Іран",
  IbG9YJ: "Острів Норфолк",
  "IrME/4": "Макао",
  XeQT0P: "Макао",
  J1oSvz: "Американські Віргінські Острови",
  JIPBj1: "Ямайка",
  JIWrkV: "Канада",
  JJhl02: "Демократична Республіка Конго",
  JOJTuh: "Коста-Рика",
  JddSbX: "Домініка",
  L7PjzJ: "Острів Різдва",
  LShUE0: "Бутан",
  "Le+IiI": "Північна Македонія",
  LeMbDw: "Замбія",
  LfkgD6: "Австралія",
  Lszars: "Сполучені Штати",
  M16xFB: "Бруней",
  MMzrYK: "Ліхтенштейн",
  MTVChl: "Тонга",
  MXueJK: "Андорра",
  MYneOz: "Джибуті",
  MZwu6r: "Острови Херд і Макдональд",
  MbV1M9: "Малайзія",
  MkBrsn: "Парагвай",
  MwNlM3: "Бурунді",
  MyB1Vf: "Саудівська Аравія",
  NcwUGt: "Ізраїль",
  OZFYbQ: "Вануату",
  OZyB9b: "Боснія і Герцеговина",
  Oc4oig: "Болівія",
  OhEAqA: "Греція",
  Oql6Jb: "Португалія",
  PB00mS: "Уолліс і Футуна",
  PBGuz3: "Польща",
  PIBLYF: "Гонконг",
  "1ObLsW": "Гонконг",
  PIHPBR: "Сен-Мартен (французька частина)",
  PjOc8o: "Білорусь",
  "Q+FGAs": "Ісландія",
  "Q5QY0+": "Кайманові Острови",
  Q5U8nY: "Американське Самоа",
  QA9U89: "Британська територія в Індійському океані",
  QRUdeg: "Мексика",
  QxRaqi: "Данія",
  RfQSLo: "Північна Корея",
  RlB4rB: "Південна Джорджія та Південні Сандвічеві Острови",
  RsWzOr: "Угорщина",
  RzKiE0: "Пуерто-Рико",
  SEJjjI: "Антарктида",
  SLmrMX: "Болгарія",
  T6qzNm: "Лаос",
  Tb6AtC: "Об'єднані Арабські Емірати",
  To4yI6: "Гамбія",
  TqXGpl: "Беліз",
  UQHsPm: "Кабо-Верде",
  UZmEHG: "Монголія",
  Ulf4Sq: "Індія",
  VCRq6v: "Острови Піткерн",
  VIFtwp: "Камерун",
  VTEHKS: "Гвінея-Бісау",
  VWg1hF: "Шпіцберген та Ян-Маєн",
  VhGXkw: "Аландські Острови",
  W2fcGi: "Суринам",
  W9gKgU: "Сейшельські Острови",
  WAl9tj: "Східний Тимор",
  "WH+mo5": "Узбекистан",
  WJAfY4: "Тувалу",
  WobBPP: "Ліберія",
  XfoqmV: "Сальвадор",
  XoOuKT: "Казахстан",
  YINkHp: "Сербія",
  YMjT8q: "Сінгапур",
  "Z+fptr": "Колумбія",
  ZHe4St: "Індонезія",
  ZRhaI4: "Барбадос",
  ZgLO7j: "Ліван",
  a9nZYf: "Острів Буве",
  aNVBIV: "Франція",
  afgUkt: "Тринідад і Тобаго",
  ahaefV: "Китай",
  b8Yur0: "Бенін",
  bCl9eg: "В'єтнам",
  bKHwtk: "Бангладеш",
  bQkGVT: "Російська Федерація",
  "cio5m/": "Нова Зеландія",
  "d+SgS7": "Нікарагуа",
  d97FOT: "Папуа-Нова Гвінея",
  dUeWgE: "Фіджі",
  dXFo2O: "Норвегія",
  dcfcTW: "Сен-П'єр і Мікелон",
  dyBAW0: "Сенегал",
  eNa9WG: "Свята Олена",
  eX9WT0: "Сан-Марино",
  eiecNW: "Лесото",
  eu7j6G: "Чорногорія",
  f6i4Ch: "Домініканська Республіка",
  fSGNZz: "Бельгія",
  fe4fox: "Судан",
  fp4MWN: "Японія",
  g44w8D: "Сполучене Королівство",
  gIZauu: "Гватемала",
  gb8v87: "Туреччина",
  h70zPD: "Іспанія",
  hB6jsF: "Кіпр",
  hBpMeF: "Маршаллові Острови",
  hC0etv: "Чилі",
  hLeEYi: "Сент-Вінсент і Гренадіни",
  hrmyDn: "Танзанія",
  htLGF6: "Бонайре",
  htNRZG: "Монако",
  hy4yn7: "Киргизстан",
  iJsE6u: "Малі",
  iVyVIA: "Гернсі",
  iYdC7o: "Непал",
  icfTwL: "Шрі-Ланка",
  icoYQF: "Французькі Південні Території",
  ipoOkJ: "Нігер",
  j2GbDK: "Сан-Томе і Принсіпі",
  "j83TV+": "Острів Мен",
  jHmcI7: "Гвінея",
  jKdq05: "Аруба",
  "jZLo+u": "Ємен",
  kCwSgm: "Швеція",
  lAVHXj: "Габон",
  lc0eVA: "Сен-Бартелемі",
  ljBSDy: "Бахрейн",
  mIgnTu: "Бермуди",
  mdbt1h: "Гренада",
  n1eYYR: "Хорватія",
  n6sdJi: "Нігерія",
  nU0AoJ: "Маврикій",
  nbVGOe: "Гаяна",
  ncprFv: "Палестина",
  nfMTZ9: "Лівія",
  "oC/YmL": "Ангола",
  oJA0AV: "Україна",
  ofe1Jv: "Словенія",
  ox0SUk: "Еритрея",
  pG9dnN: "Французька Гвіана",
  pGsPfz: "Таджикистан",
  "prG89+": "Сінт-Мартен",
  "qKL/I7": "Еквадор",
  qhRoDt: "Чехія",
  r0r576: "Австрія",
  riK5Od: "Майотта",
  "s/ZbGB": "Гібралтар",
  sVaevR: "Французька Полінезія",
  sgg3ZA: "Кенія",
  srKhxN: "Багамські Острови",
  ssKHGM: "Гренландія",
  swmjZg: "Таїланд",
  "tUisY+": "Гана",
  u3ws3s: "Південна Африка",
  u9cEKj: "Сент-Кітс і Невіс",
  uPO36O: "М'янма",
  uY8iM9: "Мозамбік",
  ufZlit: "Панама",
  ufyzs9: "Сент-Люсія",
  v8IwQb: "Аргентина",
  vPS1uD: "Перу",
  vTEjni: "Малаві",
  vcSBZu: "Бразилія",
  vixhhG: "Мальдіви",
  "wL/u2o": "Теркс і Кайкос",
  "wYCJ++": "Есватіні",
  "we/YPm": "Оман",
  xFrFSm: "Намібія",
  xV0lln: "Британські Віргінські Острови",
  xepQSL: "Кокосові (Кілінг) Острови",
  xk4ByO: "Гваделупа",
  xwICWz: "Швейцарія",
  yC4n0v: "Кувейт",
  yKWAek: "Ангілья",
  yLlbwi: "Ботсвана",
  zhs13i: "Гондурас",
  zw39MM: "Ефіопія",
  "+31PFz": "Азія/Урумчі",
  "+6yBji": "Азія/Бангкок",
  "+CgfU2": "Тихоокеанський/Ефате",
  "+POdLR": "Європа/Волгоград",
  "+VqRkg": "Америка/Кентуккі/Монтічелло",
  "/+Dhy+": "Америка/Сан-Паулу",
  "/D9zXZ": "Атлантика/Рейк'явік",
  "/UGQnF": "Америка/Ном",
  "0DYv/B": "Африка/Найробі",
  "0HnaGc": "Тихоокеанський/Кваджалейн",
  "0R8CQs": "Європа/Будапешт",
  "0xV9JO": "Америка/Аргентина/Ла-Ріоха",
  "1H4FmE": "Європа/Ужгород",
  "1mv3LM": "Азія/Чита",
  "1pl9Su": "Африка/Тріполі",
  "1sEPCz": "Азія/Токіо",
  "1ua619": "Європа/Прага",
  "23aBJh": "Америка/Денвер",
  "2DXZtH": "Європа/Копенгаген",
  "2OWj6s": "Азія/Бейрут",
  "2WXSh8": "Азія/Карачі",
  "2qYhi8": "Азія/Гонконг",
  "2s/Mlc": "Азія/Камчатка",
  "2zQAXL": "Європа/Кишинів",
  "327IN3": "Америка/Якутат",
  "339CIL": "Америка/Беліз",
  "3Lz3cq": "Тихоокеанський/Ендербері",
  "40b51E": "Америка/Мікелон",
  "4AZ4gQ": "Америка/Аргентина/Сальта",
  "4D94K+": "Антарктика/Кейсі",
  "4NXksL": "Європа/Лісабон",
  "4XF+Io": "Америка/Тегусігальпа",
  "4l3qM7": "Тихоокеанський/Нумеа",
  "4neOsl": "Америка/Данмарксгавн",
  "4wb1r/": "Європа/Люксембург",
  "5M8Wkq": "Америка/Аргентина/Жужуй",
  "5oeyFi": "Америка/Аргентина/Ріо-Гальєгос",
  "5xwaJJ": "Тихоокеанський/Фунафуті",
  "6/dk2l": "Європа/Сімферополь",
  "6Rz5js": "Африка/Ель-Аюн",
  "6XgRmz": "Азія/Ховд",
  "6d5tvh": "Америка/Боа-Віста",
  "6wYqzG": "Тихоокеанський/Вейк",
  "71fHGN": "Америка/Гаяна",
  "7Q7WxK": "Америка/Гватемала",
  "7WBtG1": "Тихоокеанський/Маджуро",
  "7euHXg": "Тихоокеанський/Бугенвіль",
  "7jiQ+M": "Азія/Тайбей",
  "82GEmf": "Тихоокеанський/Науру",
  "8DjTJi": "Тихоокеанський/Факаофо",
  "9Fhwtp": "Африка/Монровія",
  "9TfEAv": "Азія/Дакка",
  "9UC6g0": "Азія/Макао",
  "9xN38t": "Азія/Ер-Ріяд",
  A1qgI0: "Америка/Кампу-Гранді",
  A8Tpo2: "Африка/Каїр",
  ADtcg9: "Америка/Індіана/Пітерсбург",
  AQnn4z: "Азія/Катар",
  AX2M6K: "Африка/Касабланка",
  ApEhaf: "Антарктика/Восток",
  "BsRS+L": "Африка/Лагос",
  "CIpc+3": "Азія/Рангун",
  CJgAlM: "Америка/Аргентина/Буенос-Айрес",
  CMi686: "Європа/Самара",
  CRI2Ve: "Тихоокеанський/Чатем",
  CezJKN: "Америка/Сантьяго",
  "Cs/zIo": "Тихоокеанський/Маркізькі",
  CvKLCn: "Тихоокеанський/Тонгатапу",
  CwyqPj: "Африка/Аккра",
  D1tmTQ: "Америка/Північна Дакота/Центр",
  D55vg4: "Африка/Туніс",
  DAlYN5: "Європа/Стамбул",
  DCrzIX: "Європа/Андорра",
  DDqHds: "Африка/Хартум",
  DQsykN: "Америка/Гавана",
  DVZRDC: "Європа/Осло",
  DcYI27: "Африка/Мапуту",
  "EGDZo+": "Азія/Середньоколимськ",
  EcRGq9: "Азія/Дубай",
  EgIxeE: "Америка/Ямайка",
  "EnTK+r": "Америка/Чикаго",
  EqvKbF: "Америка/Куяба",
  F0y8e9: "Америка/Лос-Анджелес",
  F465cE: "Європа/Гельсінкі",
  F6OWRn: "Тихоокеанський/Порт-Морсбі",
  FDGDXD: "Європа/Київ",
  FEnpn4: "Європа/Берлін",
  FeFqOa: "Азія/Чойбалсан",
  "G0/1QH": "Америка/Парамарибо",
  "GHrEk+": "Азія/Хошимін",
  Gcuin4: "Азія/Улан-Батор",
  "H+kwCw": "Азія/Бруней",
  "H/TECz": "Азія/Сеул",
  H11GhT: "Азія/Хандига",
  HD7dNh: "Азія/Кизилорда",
  HDlqGj: "Америка/Аргентина/Тукуман",
  HSmzBV: "Америка/Аргентина/Сан-Луїс",
  I2fe6r: "Азія/Хеврон",
  ID5HGa: "Тихоокеанський/Гуам",
  "IRsI+H": "Азія/Макасар",
  IVs8gT: "Індійський/Маврикій",
  "IYKKU/": "Азія/Єреван",
  IYSP57: "Америка/Сантарем",
  JGg252: "Азія/Ділі",
  "JJJ+wW": "Тихоокеанський/Уолліс",
  JTTFhT: "Тихоокеанський/Косрае",
  KBQ98i: "Європа/Софія",
  L6RwvT: "Америка/Скорсбі",
  LFkBwb: "Азія/Куала-Лумпур",
  LGJGKo: "Америка/Індіана/Вінамак",
  LepYst: "Америка/Аргентина/Сан-Хуан",
  LrC3cb: "Африка/Йоганнесбург",
  M74J18: "Тихоокеанський/Апія",
  "MS/dmQ": "Європа/Вільнюс",
  MYvQtB: "Тихоокеанський/Понпеї",
  MhFcna: "Азія/Актау",
  MpIqyW: "Азія/Новосибірськ",
  "N69J/J": "Америка/Кайман",
  N7RBEQ: "Європа/Париж",
  "NLL9E/": "Азія/Сінгапур",
  Nap8NB: "Америка/Ла-Пас",
  NhLpaB: "Азія/Газа",
  NwiC8y: "Азія/Баку",
  OPz5aV: "Європа/Варшава",
  "OSP/DU": "Америка/Арагуаїна",
  "OoH/k4": "Європа/Мальта",
  OqlGXK: "Атлантика/Фарерські",
  OtFyGC: "Європа/Запоріжжя",
  P9EyMh: "Азія/Алмати",
  PRo9ZX: "Америка/Гранд-Терк",
  Pbr43k: "Тихоокеанський/Гамб'є",
  PdnZvE: "Америка/Індіана/Нокс",
  Phhnuu: "Тихоокеанський/Гуадалканал",
  "PlA+93": "Америка/Анкорідж",
  "Q+QFi7": "Америка/Панама",
  Q0Nwql: "Америка/Нассау",
  Q2hC7E: "Азія/Анадир",
  RTFf0R: "Азія/Ташкент",
  RVtTvI: "Америка/Богота",
  RcUwWS: "Європа/Тірана",
  Rfu8ru: "Америка/Джуно",
  RzRPhx: "Азія/Тегеран",
  SRDvbw: "Індійський/Різдва",
  SkSGFq: "Америка/Асунсьйон",
  SqYr66: "Тихоокеанський/Чуук",
  T7X3nR: "Америка/Коста-Рика",
  TnMEvg: "Європа/Рига",
  TnQgWT: "Індійський/Кокосові",
  UE61nU: "Азія/Джакарта",
  UEbt0M: "Європа/Афіни",
  UjOTtz: "Європа/Монако",
  VlcnXa: "Атлантика/Азорські",
  WICb5K: "Азія/Магадан",
  "WJ+FQF": "Азія/Тбілісі",
  WTSjw5: "Тихоокеанський/Паго-Паго",
  WUi6ng: "Азія/Кучінг",
  WX1P13: "Антарктика/Девіс",
  Wb2LCw: "Антарктика/Ротера",
  Wg0kce: "Америка/Індіана/Вінсенс",
  WhpVLY: "Америка/Гуаякіль",
  Wq4Z0k: "Америка/Белем",
  XK8hFK: "Америка/Ріо-Бранко",
  XLgiC3: "Тихоокеанський/Норфолк",
  XN4sjj: "Азія/Самарканд",
  XuXXK5: "Америка/Ресіфі",
  YOJC0Y: "Америка/Індіана/Маренго",
  Yux40Y: "Антарктика/Палмер",
  "Z+d4VE": "Європа/Амстердам",
  ZOXOj5: "Антарктика/Моусон",
  "aKg/xg": "Антарктика/Тролль",
  "aqHEW/": "Африка/Алжир",
  aqZ1dw: "Тихоокеанський/Галапагос",
  aylTTV: "Америка/Кюрасао",
  "b5+eh2": "Азія/Багдад",
  b5GT3E: "Африка/Бісау",
  bf8oMi: "Тихоокеанський/Кірітіматі",
  bkKBAQ: "Азія/Понтіанак",
  c5lOtj: "Азія/Владивосток",
  cCvy0S: "Америка/Каракас",
  ciyA6X: "Азія/Маніла",
  cl18LV: "Азія/Усть-Нера",
  d6W7pe: "Європа/Москва",
  dw9A9j: "Америка/Аргентина/Мендоса",
  e77Cv2: "Азія/Якутськ",
  e88zL2: "Азія/Нікосія",
  eDz3Tw: "Америка/Адак",
  eJqVsD: "Європа/Гібралтар",
  "eR7v+R": "Америка/Північна Дакота/Бойла",
  ekhdTj: "Азія/Джаяпура",
  "f6G4/S": "Тихоокеанський/Окленд",
  f6r66H: "Америка/Меноміні",
  fJpD6E: "Африка/Нджамена",
  fqXfBN: "Європа/Рим",
  "fxAR+x": "Азія/Орал",
  g2HLMh: "Антарктика/Сьова",
  gU3Odo: "Америка/Нью-Йорк",
  "gibo/e": "Європа/Відень",
  gln1VX: "Америка/Сальвадор",
  guiUEK: "Європа/Бухарест",
  gycX1L: "Америка/Норонья",
  h5YZ1i: "Європа/Брюссель",
  hI5EVU: "Індійський/Реюньйон",
  hKq7PN: "Європа/Калінінград",
  hL3apR: "Америка/Ліма",
  hZiOxa: "Америка/Пуерто-Рико",
  hdgzx5: "Тихоокеанський/Пасхи",
  hrq9xi: "Європа/Мінськ",
  iBXv4d: "Америка/Метлакатла",
  inPmEU: "Європа/Таллінн",
  jRwF7m: "Америка/Фінікс",
  jaNloj: "Америка/Масейо",
  jtTALf: "Тихоокеанський/Гонолулу",
  k6R7DN: "Америка/Форталеза",
  kLf0tS: "Америка/Детройт",
  lAz3SQ: "Азія/Бішкек",
  lNijTx: "Атлантика/Стенлі",
  m5vKwe: "Азія/Калькутта",
  mXs7zw: "Америка/Сітка",
  mnvAEu: "Америка/Індіана/Телл-Сіті",
  n8UW9y: "Азія/Єкатеринбург",
  nYFNxR: "Азія/Сахалін",
  o5Rywj: "Америка/Аргентина/Катамарка",
  oYmVJJ: "Азія/Красноярськ",
  ocqIaV: "Індійський/Чагос",
  ocqwXs: "Азія/Омськ",
  okHgMB: "Азія/Душанбе",
  pKp9LP: "Америка/Індіана/Вевай",
  pNrCwc: "Америка/Манаус",
  pQ5zcx: "Америка/Аргентина/Ушуая",
  pcGYLU: "Америка/Туле",
  pvDJax: "Америка/Барбадос",
  "q5++81": "Європа/Лондон",
  q7mJWt: "Америка/Бойсе",
  "qSxe/X": "Європа/Цюрих",
  rB9Ewl: "Азія/Актобе",
  rIY0ZR: "Індійський/Мальдіви",
  rZTr8Y: "Америка/Індіана/Індіанаполіс",
  rhN321: "Америка/Годтхоб",
  rslOL6: "Тихоокеанський/Тарава",
  rwZktH: "Америка/Аргентина/Кордова",
  s2obSj: "Тихоокеанський/Палау",
  s3GZlv: "Америка/Порт-оф-Спейн",
  slYOe6: "Америка/Кайєнна",
  szkWWk: "Америка/Баїя",
  t5CPbZ: "Європа/Дублін",
  tHE78L: "Америка/Санто-Домінго",
  tMDDnr: "Америка/Манагуа",
  tUaF1F: "Тихоокеанський/Ніуе",
  tlkIG3: "Тихоокеанський/Фіджі",
  "tw/bjJ": "Азія/Новокузнецьк",
  u0TM9W: "Америка/Порт-о-Пренс",
  uMXTTe: "Європа/Стокгольм",
  uNiOLq: "Азія/Єрусалим",
  "uOkO/r": "Азія/Іркутськ",
  "utbU0+": "Азія/Ашгабат",
  ux1XM2: "Атлантика/Бермуди",
  "v+arTX": "Америка/Еірунепе",
  vMATTy: "Азія/Дамаск",
  "vWWiU+": "Азія/Пхеньян",
  vbHpIo: "Африка/Віндхук",
  vn9nKr: "Америка/Порту-Велью",
  vohVUs: "Азія/Кабул",
  vwtvCc: "Атлантика/Кабо-Верде",
  vy4zY8: "Азія/Коломбо",
  w7kHCL: "Атлантика/Мадейра",
  wDFHDz: "Америка/Мартиніка",
  "wbQai/": "Атлантика/Південна Джорджія",
  wrZg4b: "Азія/Тхімпху",
  xAcBeP: "Тихоокеанський/Таїті",
  xKA8d6: "Антарктика/Дюмон-д'Юрвіль",
  "xx+5iB": "Америка/Кентуккі/Луїсвілл",
  y79PlA: "Азія/Амман",
  yaBGO1: "Тихоокеанський/Піткерн",
  yeltlL: "Індійський/Мае",
  ygabsP: "Америка/Північна Дакота/Нью-Салем",
  z6KEn9: "Тихоокеанський/Раротонга",
  z98zna: "Індійський/Кергелен",
  zWABd8: "Європа/Белград",
  zm3ZI2: "Азія/Шанхай",
  zwjmMl: "Азія/Катманду",
  "e5x+i6": "Австралия/Лорд_Хау",
  gAtxKw: "Антарктида/Маккуори",
  P5aTR8: "Австралия/Хобарт",
  "nFhe/c": "Австралия/Курри",
  e6YJm8: "Австралия/Мельбурн",
  dmcxmV: "Австралия/Сидней",
  jFnCUr: "Австралия/Брокен_Хилл",
  i5MwAy: "Австралия/Брисбен",
  WyjEwT: "Австралия/Линдеман",
  JuasJd: "Австралия/Аделаида",
  co8c88: "Австралия/Дарвин",
  qm4oIk: "Австралия/Перт",
  "0LrMZs": "Австралия/Эвкла",
  "+E914Q": "Французька (Реюньйон)",
  "+FHEub": "Центральний Атлас Тамазигт (арабська)",
  "/AAqs8": "Португальська (Екваторіальна Гвінея)",
  "/BbMQN": "Сингальська",
  "/NVZFV": "Португальська (Ангола)",
  "/V7bTl": "Фула (латиниця, Гамбія)",
  "/YFnxw": "Сахо",
  "/stiNv": "Тайська",
  "019rDM": "Португальська (Португалія)",
  "01GXUP": "Фула (латиниця, Гвінея)",
  "0BWpf+": "Японська",
  "0CHkPh": "Західнофризька",
  "0D82eT": "Хорватська (Боснія і Герцеговина)",
  "0fzUyn": "Португальська",
  "0mDCSY": "Іспанська",
  "0rqbd/": "Мальтійська",
  "160k/R": "Російська",
  "1BHQDP": "Бенгальська (Індія)",
  "1F0Uz0": "Арабська (Ірак)",
  "1J25kd": "Боснійська (слов'янська)",
  "1RqABh": "Литовська",
  "1dv927": "Малайська (Бруней)",
  "29JxAe": "Англійська (Велика Британія)",
  "2LBIWM": "Інуктітут",
  "2OXQzm": "Данська",
  "2atqiI": "Оромо",
  "2hRVBA": "Сербська",
  "30RDW+": "Арабська (Катар)",
  "3PyL86": "Англійська (Філіппіни)",
  "3Rvul8": "Тибетська (Індія)",
  "3ijo+p": "Нідерландська (Суринам)",
  "4+Zl7y": "Іспанська (Сальвадор)",
  "4Od9+t": "Сербська (слов'янська, Боснія і Герцеговина)",
  "4U3ZpB": "Французька (Гаїті)",
  "4Xzh0/": "Португальська (Швейцарія)",
  "4eGD8c": "Фула (латиниця, Сьєрра-Леоне)",
  "4fkP4F": "Іспанська (Куба)",
  "4lbmZs": "Іспанська (Філіппіни)",
  "4v0pnb": "Валлійська",
  "51lnU8": "Кельнська",
  "5KynFd": "Чеська",
  "5cyBop": "Англійська (Індія)",
  "5ff1Qr": "Тсонга",
  "5g+4ES": "Корейська (Північна Корея)",
  "5riLBC": "Сомалійська (Джибуті)",
  "5vu2sQ": "Узбецька",
  "5xPlEp": "Китайська (традиційна)",
  "62eqUV": "Північна лурі",
  "6AZb8G": "Інуктітут (освітня програма)",
  "6G/CAW": "Бельгійська",
  "6am43/": "Центральнокурдська",
  "6ebNfH": "Китайська (спрощена, Гонконг ОАР)",
  "6gtes0": "Центральний Атлас Тамазигт",
  "6sur5u": "Данська (Гренландія)",
  "7Gt5UH": "Санскрит",
  "7k8oo8": "Німецька (Австрія)",
  "7wLEyk": "Менкська",
  "7yHu97": "Латвійська",
  "8MDM0L": "Тамільська (Шрі-Ланка)",
  "8oEDHH": "Французька (Марокко)",
  "93yDUJ": "Південна саамська (Норвегія)",
  "9cbhiA": "Арабська (світ)",
  "9ftsGr": "Англійська (Малайзія)",
  "9ltErv": "Ретороманська",
  "9uEO2O": "Астурійська",
  AAf440: "Сесото са Лебоа",
  ALhR5U: "Кечуа (Перу)",
  "AQfg7+": "Французька (ДР Конго)",
  AahSYM: "Узбецька (арабська)",
  AeHTyT: "Англійська (Гонконг ОАР)",
  "B+59h1": "Монгольська (традиційна монгольська)",
  B8qZTI: "Вірменська",
  B9ZGRE: "Лаоська",
  BFf5tN: "Французька (Канада)",
  BgGwdt: "В'єтнамська",
  BpUgM5: "Нідерландська (Бонайре, Сінт-Естатіус і Саба)",
  BtqqJK: "Іспанська (Гондурас)",
  CBhHg6: "Фула (латиниця, Нігерія)",
  CDbpEz: "Ісландська",
  CFRfr5: "Дзонг-ке",
  CauPny: "Каталонська (Франція)",
  Ccf8zA: "Іспанська (Уругвай)",
  DBHTS0: "Англійська (Австралія)",
  DMjlMC: "Німецька (Бельгія)",
  DW0c2K: "Іспанська (Чилі)",
  DzWKvp: "Грузинська",
  "EP6mL+": "Маніпурі",
  EREJay: "Саамська (Луле)",
  EeOqFb: "Португальська (Сан-Томе і Прінсіпі)",
  EzFn0W: "Нідерландська (Аруба)",
  F38yZH: "Сомалійська",
  "FHLC+T": "Німецька (Ліхтенштейн)",
  Fxzz1N: "Шведська (Фінляндія)",
  FzgpJw: "Бенгальська",
  G7wzBO: "Арабська (ОАЕ)",
  "GF/5qr": "Ташельхіт",
  GGLJ5z: "Корсиканська",
  GHtHh4: "Маорі",
  "GRMM/R": "Ельзаська (Франція)",
  "GZ+vSv": "Сирійська",
  GnC74O: "Тибетська",
  GqQl0h: "Італійська",
  GsOiFJ: "Англійська (ПАР)",
  Gwyv4n: "Пенджабська",
  "H/OHWA": "Філіппінська",
  H4fFDA: "Північна саамська",
  H73FDV: "Уйгурська",
  "H7jT/h": "Албанська (Косово)",
  HDDkEc: "Зулуська",
  HVCuT9: "Англійська (Німеччина)",
  HZPa57: "Шотландська гельська",
  "Hhe/Ef": "Іспанська (Бразилія)",
  Hj8GDj: "Гуджараті",
  Hq92CJ: "Гавайська",
  HqCNsI: "Норвезька",
  "I/+zqv": "Англійська (Гернсі)",
  I42yCw: "Англійська (Канада)",
  IC7HXP: "Тигрінья",
  IDCrtf: "Фінська",
  IEUJ0j: "Німецька (Люксембург)",
  "IR/BFt": "Сомалійська (Ефіопія)",
  ItGyiB: "Каннада",
  Iz1WLp: "Урду",
  J1rnrw: "Словенська",
  J5rPWm: "Іспанська (Еквадор)",
  JPFRXM: "Англійська (Мальта)",
  JVK3dg: "Німецька",
  JkretN: "Англійська (Фінляндія)",
  Js4yYb: "Фула",
  "Jsem/p": "Могавк",
  KDsjWJ: "Стандартний марокканський тамазигт",
  "Kj/zcq": "Французька (Монако)",
  LX0RZR: "Фула (Адлам)",
  Laghvq: "Кіньяруанда",
  Ll0N3I: "Черокі",
  MESBkg: "Кхоса",
  MJQbru: "Башкирська",
  Mbp9v6: "Арабська (Сирія)",
  Mt9Ngn: "Іврит",
  N4oAho: "Сесото",
  NLZIcM: "Нідерландська (Бельгія)",
  NObQUE: "Африкаанс",
  "NV+8r2": "Мапуче",
  NVQG0j: "Дівехі",
  Nevbjx: "Фула (латиниця, Мавританія)",
  NfTD2i: "Іспанська (Венесуела)",
  NhbCYP: "Валенсійська (Іспанія)",
  NtuQMz: "Португальська (Макао ОАР)",
  "O/Bw0H": "Сербська (латиниця, Косово)",
  OKUlj2: "Угорська",
  OSMagZ: "Французька",
  Oju9iC: "Монгольська",
  P23feN: "Іспанська (Беліз)",
  "P91ei/": "Таджицька",
  PE6jNM: "Іспанська (Аргентина)",
  PO8fNg: "Португальська (Східний Тимор)",
  POQTzM: "Французька (Сенегал)",
  PSoXmh: "Одія",
  Pa7aMt: "Арабська (Ліван)",
  Pl3tfG: "Шведська",
  PsNb95: "Ірландська",
  Q8eBZk: "Нідерландська",
  QBwWZp: "Оромо (Кенія)",
  Qcitp4: "Яванська",
  Ql51WU: "Маратхі",
  R1VwTR: "Баскська",
  R325ks: "Іспанська (Латинська Америка)",
  R34HBa: "Арабська (Оман)",
  RRmxSU: "Кечуа",
  RTbzBi: "Верхньолужицька",
  RWrQ2K: "Арабська (Алжир)",
  "RqsM+G": "Іспанська (Нікарагуа)",
  SUF5bX: "Англійська (Австрія)",
  Sg9DRE: "Французька (Швейцарія)",
  SlWjJ2: "Південна саамська",
  T9IHrN: "Люксембурзька",
  TQ7V9A: "Арабська (Марокко)",
  Tddnlb: "Телугу",
  Tq0aui: "Кхмерська",
  UAHDtf: "Малаялам",
  UGFi6Q: "Арабська (Йорданія)",
  Uc1vOK: "Албанська",
  "V+BaHn": "Пушту",
  V223G2: "Фула (латиниця, Буркіна-Фасо)",
  V2uMRt: "Тамільська",
  VJbQAt: "Іспанська (Панама)",
  VKt1qn: "Непальська (Індія)",
  VuQRaN: "Італійська (Швейцарія)",
  W6zXNX: "Іспанська (Домініканська Республіка)",
  WK7YIm: "Арабська (Ємен)",
  WQtbS0: "Англійська",
  WU7Urn: "Турецька",
  WUUTG8: "Туркменська",
  Wlr6BV: "Каталонська (Італія)",
  XAmFMw: "Хорватська",
  XNXAkr: "Кечуа (Еквадор)",
  XT8v2Z: "Каталонська",
  XjbxJQ: "Африкаанс (Намібія)",
  Xkmde4: "Китайська (спрощена, Макао ОАР)",
  Xx527p: "Північна саамська (Швеція)",
  Y7CQhy: "Швейцарська німецька",
  Y8mZTh: "Англійська (Ямайка)",
  Y941O5: "Словацька",
  YNjb1t: "Фарерська",
  Ygp3rn: "Боснійська",
  "Z/MVyq": "Церковнослов'янська",
  ZCh9e6: "Нижньолужицька",
  ZQtURc: "Румунська (Молдова)",
  ZjrmiJ: "Шона",
  "Zki/XJ": "Казахська",
  a9U6ge: "Корнська",
  aO94Wj: "Урду (Індія)",
  "aTZE+x": "Кашмірська (деванагарі)",
  aiXFTk: "Фула (латиниця, Гана)",
  bDNNJp: "Малайська (Індонезія)",
  bLqBa4: "Англійська (Нова Зеландія)",
  bRIPjy: "Англійська (Ізраїль)",
  "bT+IsS": "Малайська (Сінгапур)",
  bVuD3F: "Арабська",
  bfp8tQ: "Гренландська",
  c3rP5p: "Англійська (Словенія)",
  cJbw13: "Китайська (традиційна, Тайвань)",
  cQRIur: "Англійська (Сінгапур)",
  d5MtIX: "Індонезійська",
  dEIOuD: "Польська",
  dPzT2w: "Бретонська",
  drEx3O: "Суахілі",
  e9Fovw: "Пап'яменто",
  eGmwHh: "Англійська (Швейцарія)",
  eSg76K: "Англійська (Гібралтар)",
  eSmbEf: "Ірландська (Велика Британія)",
  eWnJnC: "Гінді",
  efy66J: "Чеченська",
  "f+NB92": "Іспанська (Перу)",
  "f/8iNS": "Фула (латиниця, Камерун)",
  "f5+iem": "Іспанська (Мексика)",
  f6Viji: "Пушту (Пакистан)",
  fkHabQ: "Кіче",
  fv9aDa: "Саамська (Інарі)",
  "gHco+M": "Російська (Молдова)",
  gOsLMk: "Малагасійська",
  gWx9ey: "Сербська (латиниця, Чорногорія)",
  gfmlPE: "Англійська (Ірландія)",
  glnMAY: "Ташельхіт (латиниця)",
  gvaI7A: "Сомалійська (Кенія)",
  "h6q+Tn": "Прусська",
  h9YX8r: "Тамільська (Сінгапур)",
  "hEPDg/": "Окситанська",
  hNSwvJ: "Фула (латиниця, Ліберія)",
  hcX72z: "Тамільська (Малайзія)",
  hmzrxz: "Північна саамська (Фінляндія)",
  hr7Bt0: "Португальська (Гвінея)",
  i4jvwu: "Китайська",
  "i5/TH8": "Іспанська (Екваторіальна Гвінея)",
  "iI431+": "Англійська (Нідерланди)",
  iKxsEO: "Непальська",
  iTiaM1: "Гуарані",
  iXn58z: "Азербайджанська (слов'янська)",
  ifdXl3: "Корейська",
  jG6ZfL: "Німецька (Італія)",
  jGXHMX: "Сербська (латиниця, Боснія і Герцеговина)",
  "jHvE/3": "Н'ко",
  joVZ4M: "Арабська (Єгипет)",
  "k+bU6l": "Нідерландська (Сінт-Мартен)",
  k6RCbu: "Португальська (Люксембург)",
  kW1ixl: "Суахілі (Уганда)",
  l8f1rC: "Кашмірська",
  lGAoQJ: "Суахілі (Танзанія)",
  "lig/ia": "Бодо",
  lwerC3: "Іспанська (США)",
  "m+zQs1": "Ігбо",
  m421XM: "Українська",
  "mP+2ZR": "Англійська (Тринідад і Тобаго)",
  mQ30Fl: "Англійська (Фолклендські острови)",
  mQPNAb: "Сіндхі",
  mgFsmM: "Англійська (Данія)",
  "mkyn/R": "Арабська (Бахрейн)",
  mq4oU3: "Англійська (Джерсі)",
  mvxq4r: "Галісійська",
  n86rIs: "Киргизька",
  naThLg: "Грецька",
  ncJAOw: "Бірманська",
  nfKkEe: "Фула (латиниця, Нігер)",
  nzfKPJ: "Французька (Камерун)",
  "oCgi+u": "Амхарська",
  "oh7xe+": "Саамська (Луле, Норвегія)",
  oiHWuC: "Німецька (Швейцарія)",
  ono6Zw: "Іспанська (Гватемала)",
  ouSGKF: "Саамська (Скальт)",
  pJE11U: "Сетсвана (Ботсвана)",
  pVxDdM: "Мазандаранська",
  pcWfuB: "Сетсвана",
  pdfcvu: "Французька (Кот-д'Івуар)",
  pjF6Nn: "Сесото (Лесото)",
  pqIrOS: "Арабська (Туніс)",
  q2N4yn: "Сербська (слов'янська)",
  qQDW8M: "Французька (Малі)",
  qRbMrx: "Йоруба",
  qYdUNv: "Центральний Атлас Тамазигт (тифінаг)",
  qu9gJ5: "Арабська (Лівія)",
  qwSYAN: "Португальська (Мозамбік)",
  r8ZWqf: "Нюношк норвезька",
  rcixhA: "Нідерландська (Кюрасао)",
  rcmyN3: "Перська (Афганістан)",
  rk5DA1: "Англійська (Бельгія)",
  sBC8AY: "Сіндхі (деванагарі)",
  sHbxv8: "Англійська (Беліз)",
  sRuB7H: "Малайська",
  sl0qaQ: "Арабська (Кувейт)",
  sliV2n: "Іспанська (Парагвай)",
  syMU2g: "Французька (Бельгія)",
  tQJpug: "Каталонська (Сардинія)",
  tQi27b: "Конкані",
  tRgqyZ: "Сербська (слов'янська, Косово)",
  tdrfAE: "Англійська (Карибський басейн)",
  u0KReQ: "Італійська (Ватикан)",
  u61cWR: "Іспанська (Колумбія)",
  u78bW4: "Македонська",
  uCI04p: "Естонська",
  uVRPPZ: "Татарська",
  ubfX8q: "Англійська (Зімбабве)",
  uh1OQN: "Волоф",
  upv4s2: "Португальська (Кабо-Верде)",
  vSG3D5: "Іспанська (Коста-Рика)",
  viRRMu: "Сербська (слов'янська, Чорногорія)",
  vo99Cy: "Англійська (Бурунді)",
  vuf8EY: "Англійська (Британські Віргінські острови)",
  vxR1y4: "Хауса",
  wVqnrV: "Перська",
  wra0CG: "Суахілі (Конго)",
  wtZRFn: "Фріульська",
  x0KMJr: "Англійська (Острів Мен)",
  xXkK79: "Монгольська (традиційна монгольська)",
  xeXtGt: "Англійська (Швеція)",
  xgB0JY: "Ассамська",
  xoMuR7: "Вальзерська",
  "xzWaZ/": "Іспанська (Пуерто-Рико)",
  "y//NHV": "Азербайджанська",
  y7nOlh: "Болгарська",
  ydTOo2: "Французька (Люксембург)",
  z0tSbC: "Осетинська",
  z1VBi8: "Румунська",
  zBWf5p: "Інтерлінгва",
  zWU1xI: "Іспанська (Болівія)",
  "05KCjo": "Значок приложения:",
  "11uVJ/": "Получить объект",
  "1Qoc6t": "Имя процесса:",
  "2JW1Pt":
    "Пожалуйста, выберите, отправлять ли электронные письма одновременно",
  "70JpVD": "Имя процесса",
  "9AsSO/":
    "Пожалуйста, выберите, отправлять ли текстовые сообщения одновременно",
  "AH+jWQ": "Приложение Windows",
  Axagls: "Пожалуйста, выберите время окончания",
  FNIJXx: "Пожалуйста, выберите воспроизведение с прокруткой",
  Fir0oq: "Пожалуйста, выберите тип уведомления",
  G4qgGm: "Все пользователи",
  G5gg2V: "Требуется заголовок объявления",
  IWPf2S: "Детали объявления",
  IbWDVg: "Требуется номер версии",
  Km733q: "Пожалуйста, выберите время начала",
  L24ioQ: "Название",
  L80hmc: "Название объявления не должно превышать 30 символов",
  NDjXUx: "Введите команду для развертывания файла:",
  "Oex59+": "Список возврата",
  QHc9Qg: "Содержимое объявления",
  QNomO6: "Пожалуйста, введите номер версии",
  Qpcx6F: "Требуется содержание объявления",
  RQyKsa: "Объявление платформы",
  TiK9WZ: "Требуется имя процесса",
  TvOGLc: "Команда файла развертывания",
  UHuNzJ: "Пожалуйста, введите команду",
  WtPk7v: "Отправлять SMS одновременно",
  XbIN5K: "Пожалуйста, введите имя программы",
  XeIKK7: "Центр уведомлений",
  ZqioaF: "Название уведомления",
  aGxRt2: "содержание",
  cr1ymH: "Пожалуйста, выберите время отправки",
  dY3og7: "Значок загрузки приложения:",
  eFDqHN: "Загрузить приложение Windows успешно",
  eSfTZf: "Загрузить приложение Windows",
  "ghKe/+": "имя процесса",
  "h5yj+x": "Пожалуйста, введите имя процесса",
  jAJbuk: "Объявление об уведомлении",
  l36W55: "Воспроизведение прокрутки",
  lqQKL4: "Добавить по имени процесса",
  mKKd1R: "Пожалуйста, выберите получателей",
  q9PHLT: "Объявлений пока нет",
  wYygRu: "Отправитель",
  xXdMar: "Указанный пользователь",
  xx40g7: "Название объявления",
  yKFvYY: "Отправлять электронные письма одновременно",
  yfhtRM: "Вложение",
  z5L9EV: "Обновить приложения Windows",
  "bhv+8O": "Загрузка",
  xzmRTb: "Отображать историю только за последние 7 дней",
  "yrR/HC": "Установка",
  ibYzs0: "Название программы: {name}",
  ivzCMK: "Невозможно проанализировать приложение.",
  mJBhe1: "Синхронизация файлов позволяет добавить до 10 файлов",
  "6oXjFu": "Формат загрузки неправильный",
  KetfTt: "Максимальный размер изображения: 500 КБ",
  baNBmh: "Размер изображения не может превышать 500 КБ",
  tAjFr2: "Форматы изображений: PNG, JPG, JPEG, BMP, GIF, SVG, WEBP",
  "3K02K/": "Неполная конфигурация Wi-Fi",
  "5Cm9U3": "Уведомление о сообщении",
  "Y6Q+iJ": "Пожалуйста, заполните конфигурацию Wi-Fi",
  tugHWJ: "Вернуться к списку объявлений",
  "x/FhNQ": "Просмотр уведомлений",
  "+GRUnH": "Азия/Ховд",
  "+IL2pH": "Азия/Эр-Рияд",
  "+J2Dyk": "Америка/Асунсьон",
  "+Ny8AK": "Америка/Пуэрто-Рико",
  "+RWig5": "Испанский (Боливия)",
  "/2Wzyw": "Америка/Сальвадор",
  "/rG/9z": "Америка/Кюрасао",
  "0AuprP": "Тихий океан/Тонгатапу",
  "0X3KFO": "Температура ЦП",
  "0vIw5o": "Америка/Богота",
  "1YfhFP": "Азия/Дили",
  "2+A7qs": "Антарктида/Моусон",
  "2+ec6P": "Америка/Денмарксхавн",
  "2FPNxz": "Азия/Дубай",
  "32RJkL": "Америка/Аргентина/Сан-Луис",
  "33VS8L": "Америка/Масейо",
  "36csPo": "Европа/Цюрих",
  "3KlQfs": "Австралия/Брисбен",
  "3LAnU7": "Атлантика/Фарерские острова",
  "3MaR6w": "Европа/Таллин",
  "3NE037": "Азия/Ашхабад",
  "3svavz": "Америка/Микелон",
  "42xSxy": "Азия/Новосибирск",
  "4LAo5S": "Америка/Метлакатла",
  "4Sw/d9": "Азия/Красноярск",
  "4T/bEM": "Америка/Индиана/Вевей",
  "4WaJo8": "Америка/Скорсбисунд",
  "4Wgk5f": "Европа/Андорра",
  "4ZRHuu": "Атлантика/Южная Георгия",
  "4cXOI/": "Азия/Ереван",
  "4jryq3": "Америка/Северная Дакота/Нью-Салем",
  "4sqSH4": "Азия/Хандыга",
  "564gFy": "Африка/Аккра",
  "6SQvm5": "Азия/Понтианак",
  "6X6msx": "Использование хранилища",
  "6xnHrJ": "Европа/Берлин",
  "72KWoU": "Австралия/Сидней",
  "778/Xc": "Америка/Тегусигальпа",
  "7JA1Vf": "Америка/Аргентина/Мендоса",
  "7L+CJm": "Европа/Хельсинки",
  "7geAkY": "Америка/Аргентина/Буэнос-Айрес",
  "7teo40": "Тихий океан/Чуук",
  "87d7yX": "Тихий океан/Гуадалканал",
  "8Gi8qJ": "Австралия/Брокен-Хилл",
  "8eL/hC": "Азия/Иерусалим",
  "8hJsOE": "Азия/Бангкок",
  "8qYKWy": "Тихий океан/Чатем",
  "8woxjy": "Азия/Куала-Лумпур",
  "A3y/jB": "Америка/Аргентина/Рио-Гальегос",
  ACHtOA: "Азия/Камчатка",
  AFZYEo: "Азия/Бруней",
  ALGNzc: "Азия/Магадан",
  AWhHY3: "Америка/Риу-Бранку",
  ApnLV0: "Азия/Алматы",
  AqKGKn: "Азия/Джакарта",
  As1lP0: "Индийский океан/Кергелен",
  "Aytpe/": "Европа/Монако",
  B6rikn: "Америка/Индиана/Индианаполис",
  B9NkmN: "Европа/Люксембург",
  BXdJNy: "Атлантика/Стэнли",
  BgYCgo: "Антарктида/Кейси",
  C21hEn: "Европа/Белград",
  C7HjWu: "Европа/Амстердам",
  CBkGYl: "Африка/Мапуту",
  CC9Jw3: "Азия/Макасар",
  CIImWq: "Тихий океан/Маджуро",
  "CNMmH/": "Азия/Якутск",
  CR8w2m: "Америка/Гранд-Терк",
  CUsFOe: "Америка/Кайенна",
  D2gXtv: "Америка/Меномини",
  D4VBw5: "Антарктида/Дюмон-д'Юрвиль",
  DincSy: "Австралия/Лорд-Хау",
  DoPuye: "Азия/Дамаск",
  "E/3oPZ": "Азия/Макао",
  E2NUw6: "Африка/Йоханнесбург",
  EJA24j: "Тихий океан/Норфолк",
  EgGVTj: "Тихий океан/Эндербери",
  EhPWhM: "Америка/Куяба",
  EmxcJt: "Америка/Якутат",
  Ewhh7n: "Европа/София",
  FXD37C: "Америка/Панама",
  FsXquv: "Азия/Пхеньян",
  GIHcco: "Америка/Нуук",
  GIwuGT: "Европа/Брюссель",
  GNkv6K: "Африка/Эль-Аюн",
  "H8+X66": "Азия/Кандыга",
  HDVqMh: "Америка/Аргентина/Сан-Хуан",
  HEpXP8: "Америка/Денвер",
  HOEyDX: "Америка/Ла-Пас",
  HS4Jyv: "Европа/Ужгород",
  Hh1tUP: "Америка/Гуаякиль",
  HkGIFU: "Антарктида/Дейвис",
  HoSy6c: "Тихий океан/Кваджалейн",
  HuSwkp: "Азия/Усть-Нера",
  HzSbcD: "Антарктида/Тролль",
  I3bX6d: "Азия/Урумчи",
  IBZBgD: "Европа/Стамбул",
  IHXrCK: "Америка/Лос-Анджелес",
  IKeroX: "Азия/Джаяпура",
  ILjenb: "Америка/Индиана/Маренго",
  IgbKn9: "Азия/Хошимин",
  InLlSF: "Америка/Парамарибо",
  J5iABC: "Азия/Карачи",
  JHjx5l: "Америка/Анкоридж",
  "JURm/W": "Антарктида/Палмер",
  "Jc5/LG": "Азия/Омск",
  JrjIBq: "Америка/Порт-о-Пренс",
  K9TF6H: "Азия/Гонконг",
  KAKu2d: "Тихий океан/Нумеа",
  KEr7iI: "Тихий океан/Палау",
  "KaS+yS": "Америка/Коста-Рика",
  KyBesr: "Тихий океан/Раротонга",
  M3Bd2i: "Тихий океан/Питкэрн",
  MAVhWe: "Европа/Осло",
  MAWdwn: "Азия/Коломбо",
  McxhaP: "Америка/Белиз",
  MeSuny: "Америка/Барбадос",
  MmTr9O: "Африка/Каир",
  Mr4JiU: "Индийский океан/Чагос",
  MxWLCa: "Тихий океан/Маркизские острова",
  NW4CG5: "Африка/Триполи",
  NWpmvK: "Европа/Москва",
  Nd0dlz: "Америка/Аргентина/Катамарка",
  NhHERf: "Африка/Хартум",
  O2VzkZ: "Европа/Гибралтар",
  OEWR5m: "Америка/Ресифи",
  OPvCOV: "Атлантика/Рейкьявик",
  OdITFl: "Индийский океан/Кокосовые острова",
  Oj7H2e: "Европа/Мальта",
  OnT6Rq: "Америка/Аргентина/Сальта",
  P5ijks: "Азия/Чита",
  P8Gz8g: "Азия/Самарканд",
  P8fuMA: "Тихий океан/Апиа",
  PE4Jv1: "Европа/Калининград",
  "PHe5b/": "Америка/Сан-Паулу",
  PQTASm: "Африка/Найроби",
  PSTE5v: "Азия/Тегеран",
  "Pr/HJJ": "Америка/Туле",
  Q93ucv: "Европа/Дублин",
  Q9eZjv: "Америка/Лима",
  QIrZ4x: "Тихий океан/Косраэ",
  QXW2mv: "Америка/Аргентина/Тукуман",
  QlNyHt: "Азия/Сеул",
  RWGdDh: "Европа/Бухарест",
  RWhf30: "Тихий океан/Окленд",
  RbCEhx: "Америка/Кентукки/Луисвилл",
  RdB8rs: "Америка/Кентукки/Монтиселло",
  Ri5GFC: "Европа/Волгоград",
  Rzjtg0: "Антарктида/Маккуори",
  "SB+r6t": "Индийский океан/Рождественский остров",
  "SDmnE+": "Азия/Амман",
  SO2rVX: "Африка/Виндхук",
  TSIb1O: "Азия/Бейрут",
  TVzP2K: "Тихий океан/Остров Пасхи",
  TmXGJf: "Тихий океан/Паго-Паго",
  Tp6vAo: "Атлантика/Азорские острова",
  "Tvk1/+": "Азия/Баку",
  TxnfAW: "Европа/Симферополь",
  UU6RxP: "Тихий океан/Факаофо",
  "W+BF0N": "Европа/Киев",
  WF6jLL: "Азия/Иркутск",
  WGbNbT: "Европа/Рим",
  WH83gM: "Австралия/Юкла",
  WM9F6N: "Европа/Будапешт",
  WT4u2Q: "Африка/Бисау",
  Wd588a: "Америка/Джуно",
  "X+krOQ": "Европа/Лондон",
  XG3VTC: "Индийский океан/Мальдивы",
  XGLQKt: "Индийский океан/Маврикий",
  XJz9XQ: "Америка/Чикаго",
  XcLHzQ: "Америка/Санто-Доминго",
  XgCqrC: "Азия/Кучинг",
  "Xs2qb/": "Азия/Шанхай",
  YUT4gj: "Европа/Лиссабон",
  YZ2GGD: "Азия/Сингапур",
  "Ywxpi/": "Индийский океан/Маэ",
  Z0uRcM: "Азия/Дакка",
  ZKdJhk: "Америка/Боа-Виста",
  ZZib2d: "Австралия/Хобарт",
  Zjiy1h: "Тихий океан/Науру",
  ZnA7Nz: "Азия/Хеврон",
  a25tfu: "Азия/Калькутта",
  a4hALt: "Европа/Самара",
  aIkFIc: "Европа/Рига",
  aJXo8B: "Азия/Сахалин",
  an8KV9: "Европа/Стокгольм",
  "bPKD9+": "Америка/Баия",
  bpugpH: "Тихий океан/Галапагос",
  bwibOg: "Америка/Индиана/Телл-Сити",
  bwxucD: "Антарктида/Ротера",
  byIMHD: "Америка/Индиана/Уинамак",
  cGo7xU: "Европа/Вена",
  cL4iBR: "Тихий океан/Уэйк",
  cR6lQr: "Америка/Нью-Йорк",
  cY9R69: "Азия/Янгон",
  "cdP+DQ": "Загрузка памяти",
  cfqioE: "Америка/Мартиника",
  ckkIgb: "Америка/Сантарен",
  "d+p45H": "Антарктида/Восток",
  "dD/ri/": "Тихий океан/Эфате",
  dVOPAi: "Мониторинг отключенных устройств",
  dmQidl: "Тихий океан/Уоллис",
  dnhrx5: "Европа/Афины",
  dsc2e1: "Америка/Кампу-Гранди",
  dwtkZ7: "Атлантика/Кабо-Верде",
  e7x56t: "Америка/Эйрунепе",
  eCaCt4: "Европа/Копенгаген",
  eJ850A: "Америка/Каракас",
  eUPrSB: "Америка/Аргентина/Кордова",
  "eiH+8b": "Африка/Нджамена",
  esrASO: "Америка/Манаус",
  "f/kdJq": "Азия/Душанбе",
  f2wvqe: "Азия/Кызылорда",
  fRTjpp: "Америка/Порт-оф-Спейн",
  felOXC: "Европа/Минск",
  "fr++q+": "Америка/Северная Дакота/Центр",
  fwXmSX: "Индийский океан/Реюньон",
  g8yytK: "Прочитано",
  g9Ro8s: "Азия/Тхимпху",
  gCnWv3: "Америка/Гватемала",
  "gWP+OK": "Америка/Порту-Велью",
  gY9Idz: "Содержание уведомления",
  hMJvQy: "Азия/Актобе",
  hMvFT8: "Тихий океан/Фиджи",
  i9kfO3: "Австралия/Перт",
  ia2KGW: "Австралия/Линдеман",
  iemojj: "Америка/Индиана/Питерсбург",
  iktlFx: "Африка/Лагос",
  ioR1tU: "Австралия/Мельбурн",
  irTGxZ: "Америка/Нассау",
  iuG5L2: "Тихий океан/Фунафути",
  jArote: "Азия/Чойбалсан",
  jGg3Qb: "Атлантика/Бермуды",
  "kPnKK/": "Тихий океан/Тарава",
  kQfkBY: "Тихий океан/Ниуэ",
  kX80z5: "Африка/Касабланка",
  kb4vnt: "Азия/Тбилиси",
  kibwvT: "Америка/Арагуайна",
  klPlFN: "Атлантика/Мадейра",
  ktaxSw: "Непрочитано",
  kzL66g: "Америка/Ситка",
  l0DTVX: "Европа/Кишинев",
  l3HZXk: "Америка/Аргентина/Жужуй",
  lUObgG: "Азия/Новокузнецк",
  "lY+G1f": "Европа/Запорожье",
  ldw5JF: "Америка/Гавана",
  ldz3Qp: "Америка/Ном",
  "luv+ak": "Антарктида/Сёва",
  m372k4: "Азия/Актау",
  mC90qt: "Америка/Фернанду-ди-Норонья",
  maWrSV: "Азия/Катар",
  mpmcYh: "Америка/Ямайка",
  mzw9vO: "Азия/Владивосток",
  nFRGgT: "Азия/Никосия",
  nG6bDa: "Тихий океан/Понпеи",
  nNIaxy: "Австралия/Курри",
  "nTx/do": "Африка/Монровия",
  ndfOI1: "Азия/Ташкент",
  nfV4cd: "Тихий океан/Порт-Морсби",
  nt7Sni: "Америка/Феникс",
  "oNgMl/": "Европа/Варшава",
  ox9xcC: "Азия/Улан-Батор",
  "p/Y+A9": "Азия/Орал",
  p60kqM: "Америка/Индиана/Нокс",
  "pDAAq+": "Тихий океан/Рождество",
  "pH7u/B": "Европа/Прага",
  pctdGN: "Тихий океан/Таити",
  pkQvvT: "Азия/Газа",
  qZesUE: "Тихий океан/Бугенвиль",
  qm1rPH: "Америка/Адак",
  qrxb3P: "Америка/Манагуа",
  qyspJO: "Азия/Багдад",
  rB8hza: "Америка/Бойсе",
  rDnYpj: "Америка/Детройт",
  "rSU+yK": "Европа/Тирана",
  rhrAj5: "Азия/Манила",
  sCbQzB: "Тихий океан/Гуам",
  ssEhAp: "Австралия/Дарвин",
  tGy5jw: "Азия/Бишкек",
  tb5CXr: "Европа/Париж",
  u8OEeb: "Азия/Анадырь",
  umaIEg: "Америка/Аргентина/Ушуайя",
  "uq/hF0": "Азия/Токио",
  v1R8a6: "Америка/Гайана",
  v9QImt: "Азия/Кабул",
  vvPXpH: "Азия/Катманду",
  w6MqYv: "Америка/Белем",
  "wHl/4A": "Австралия/Аделаида",
  wQ6hxa: "Африка/Тунис",
  wTov5v: "Америка/Форталеза",
  wu6z2j: "Тихий океан/Гамбье",
  xC5dF9: "Африка/Алжир",
  xV1AHg: "Азия/Екатеринбург",
  xV72W5: "Америка/Сантьяго",
  "xefyX+": "Америка/Северная Дакота/Бьюла",
  yBB7Af: "Америка/Аргентина/Ла-Риоха",
  yjTwMp: "Азия/Тайбэй",
  yk6eIX: "Тихий океан/Гонолулу",
  z4BN1R: "Америка/Кайман",
  zMTRSM: "Загрузка ЦП",
  zOIpOr: "Америка/Индиана/Винсенс",
  zooIwl: "Европа/Вильнюс",
  "/+bsEl": "Америка/Монтеррей",
  "/Gtqfz": "Америка/Меріда",
  "22S38U": "Америка/Атікокан",
  "3TyuhP": "Америка/Ojinaga",
  "3nz5UA": "Африка/Абіджан",
  "5LGVs8": "Америка/Інувік",
  "5hwp3A": "Америка/Вінніпег",
  "75rZvt": "Америка/Форт_Нельсон",
  B1cpxi: "Америка/Баїя_Бандерас",
  DB1i32: "Америка/Чихуахуа",
  EjYbG7: "Атлантичний/Канарський",
  JJlhYG: "Америка / Монктон",
  JK7opY: "Америка/Rainy_River",
  JMiQE7: "Америка/Swift_Current",
  JNgj9q: "Америка/Ванкувер",
  LQs9br: "Америка/Крестон",
  TV0vfT: "Америка/Ермосільо",
  TtsBNI: "Америка/Santa_Isabel",
  "V/ychw": "Америка/St_Johns",
  V3RDY8: "Америка/Кембридж_Бей",
  WrrSc3: "Європа/Мадрид",
  XAJf4I: "Америка/Єллоунайф",
  Xf2rFn: "Америка/Мазатлан",
  "YIziP+": "Америка/Rankin_Inlet",
  Zw6GOE: "Америка/Регіна",
  cvhrwM: "Америка/Pangnirtung",
  d4TeTf: "Америка/Вайтхорс",
  dS4Q9B: "Америка/Едмонтон",
  dXgU6w: "Америка/Матаморос",
  damxMJ: "Америка/Ніпігон",
  hrTtyK: "Америка/Dawson_Creek",
  i7y8PO: "Африка/Сеута",
  mYnwj6: "Америка/Ікалуіт",
  mZSYZK: "Америка/Канкун",
  n4UQqL: "Америка/Доусон",
  pIep8S: "Америка/Мехіко_Сіті",
  pZHBxH: "Америка/Рішуча",
  puzgCP: "Америка/Торонто",
  sf6FE5: "Америка/Glace_Bay",
  trLh1J: "Америка/Тіхуана",
  vmXV5r: "Америка/Бланк-Саблон",
  x062Q4: "Америка/Галіфакс",
  x5t5ol: "Америка/Тандер_Бей",
  x8MKpa: "Америка/Goose_Bay",
  "5EJNIu": "выполните поиск устройств по компаниям",
  qhku2P: "(Windows 7 пока не поддерживается)",
  LjaYAu:
    "(Устройство автоматически перезагрузится после применения настроек.)",
  SsOQaU: "Необходимо указать путь к устройству Android",
  ftJgyV: "Устройство необходимо проверить",
  tp71Dv: "Необходимо указать путь к устройству Windows",
  "+x/2kt": "Правила устройства",
  "781mpm": "3. Правила именования компании по умолчанию",
  EJYMZz:
    "После закрытия вы можете скачать новую версию Ора и установить ее самостоятельно, либо обновить вручную через команду устройства-Обновление Оры.",
  QWNGGT: "Количество устройств",
  QkSHo2:
    "После отключения автоматического обновления различия в версиях Ora на устройстве могут привести к тому, что некоторые функции станут недоступны",
  RFear4: "2. Период обновления устройства (местное время)",
  VUYwkz: "Пожалуйста, выберите приложение",
  Z8Wkvb:
    "После включения Ora автоматически загрузит и обновит, если появится новая версия.",
  bc4BgP: "Последний раз в сети",
  c5daOt: "Количество магазинов ({num})",
  qDHqff: "Автоматический перезапуск",
  zbqD5q: "значение",
  FtTdh0: "1. {ora} автоматически обновляется",
  Em0SLE: "Перезапустить",
  Gvm3Ry:
    "Вы уверены, что хотите перезапустить {appName} из ({name})? Мониторинг приложений продолжится после перезапуска.",
  Ixi8kg: "Напоминание о перезагрузке",
  bbMhTk: "Вы уверены, что хотите перезапустить?",
  "99tjyG": "IP",
  "9a/nvJ": "Результат операции",
  BdDDD0: "Журнал устройства",
  MbqxKj: "Имя шаблона",
  OjLqmy: "Неизвестно",
  V6d4dz: "Подробности операции",
  "hD/l+2": "Тип операции",
  "s+OQvW": "Оператор",
  yc8eep: "Выбрать результаты",
  "/5RjKG": "Отказ токена",
  "0nwYmb": "Все типы уведомлений",
  "ZC7J/S": "Тип уведомления",
  pm5kAg: "Пожалуйста, посмотрите подробнее",
  y8e4w8: "Вступает в силу только после перезапуска устройства",
  vjxfR4: "(Установщик exe, файл msi)",
  "8DORrA": "USB-порт",
  AFx0WP: "Тип поиска",
  GyqBiS: "Распечатать информацию",
  L3HWwz: "Описание устройства",
  OuXnTb: "Вы уверены, что хотите сбросить настройки этого USB-порта?",
  "QZM++f": "Вы уверены, что хотите сбросить настройки принтера?",
  RCjVsb: "ИД устройства",
  RJpihQ: "Вы уверены, что хотите отключить этот USB-порт?",
  adMZWx: "Добавить периферийные устройства",
  j3iWkN: "Принтер не может быть повторен",
  kL3ndq: "Вы хотите удалить этот принтер?",
  r8lAlx: "Управление периферийными устройствами",
  wIFJtf: "Не подключено",
  zKsJJS: "Вы уверены, что хотите включить этот USB-порт?",
  "zY36V+": "Подключено",
  "2Rco7+": "Время загрузки:",
  "5JrKIs": "Развертывание функции запланировано на выбранное время выпуска.",
  E62yo0: "Развертывание функции не удалось, повторная попытка.",
  HI9nIp: "Удалить файлы",
  IX5jed: "Состояние развертывания файла конфигурации",
  Mxw3XE: "BAT-файл не имеет имени install или uninstall",
  "N3h+Aq": "Развертывание функции не удалось",
  N9kr00: "Удалить приложение после переноса",
  "OY+bYK": "Подтвердить, больше не показывать",
  PZD5BD:
    "Этот проект используется файлом конфигурации [{name}] и не может быть удален. Если вы хотите удалить проект, удалите его из файла конфигурации",
  Pzsa4g: "Развертывание функции готово",
  RzXkm3: "Черный список включен",
  SzN0Xf: "Удалить владельца устройства",
  VvutjQ: "Функция",
  XPoLPc:
    "Развертывание функции получено и будет обработано в ближайшее время.",
  Xsx53E: "Вы уверены, что хотите удалить этот файл?",
  c7ABGP: "Развертывание функции ожидает ответа Ora",
  d6mNdO: "Белый список включен",
  f9tP6e: "Вы уверены, что хотите удалить это приложение Windows?",
  hmCei2: "Удалить приложение после удаления",
  ii1TCF:
    "(Пожалуйста, назовите bat-файл в сжатом пакете install или uninstall)",
  mmGD7U: "Выполняется развертывание функции.",
  uL4MGN: "Вы уверены, что хотите удалить это приложение Android?",
  wzPSgE: "Черный список/Белый список",
  xAk1ic: "Функция успешно развернута",
  yWzW01: "(установщик exe, файл msi, сжатый zip-пакет)",
  yvnu2T: "Имя шаблона конфигурации",
  "CqT/5i": "Этим файлом поделились. Вы уверены, что хотите удалить его?",
  wboZY3: "Время отчета",
  "6kNt8v": "Следующий час",
  Rkh3mc: "Последний час",
  "+/nbWD": "Следующее изменяемое время {time}",
  "1ULJr+": "Режим одного приложения",
  CxuMXm: "Необходимо добавить приложение",
  Gp3iu0: "Загрузить локальные обои",
  M0GExq:
    "Если на устройстве уже есть приложение, удалите исходную версию и переустановите его",
  OYWCEU: "Локальное приложение для загрузки",
  PyHYs3: "Закрыть VNC-соединение",
  QZCAIP: "ИД приложения",
  "X+8ega": "Выбор режима киоска",
  "bLP2/B": "Проверьте статус приложения настройки",
  bneXBI: "Изменить запрос",
  czLSET: "Вручную добавить приложение",
  eg9Cwk: "Из компании текущего местоположения",
  f8ijF3: "Команда была выдана",
  i8wqAy: "Загрузить локальное приложение",
  oiRBSj:
    "После подтверждения устройство применит новые настройки. Вы уверены, что хотите применить их?",
  "qG2/EZ": "Локальная загрузка файла",
  "qH+vs7": "Белый список",
  qTgFpp: "От компании, которой принадлежит аккаунт",
  qwHBkg:
    "Нет записей об изменении настроек, все устройства используют настройки по умолчанию",
  sB85Wu: "Локальная загрузка",
  uqEE8V: "Эта конфигурация применима только к Android Ora 2.14.25",
  vtUGfp: "Правила именования компании по умолчанию",
  QgHuyM: "Правила именования магазинов",
  "+Bas2b": "Длительность: {duration}",
  "+a6DnG": "На рассмотрении",
  "/CFd+q": "Открыть",
  "0JQoTX": "Проверка не пройдена",
  "0Ru5zG": "Размер: {size}",
  "0UhE3z": "Статус воспроизведения",
  "0btyN9": "Длительность:",
  "1/U2kj": "Видео",
  "1qoi3T": "Изображение",
  "3HqLlX": "Новый контент",
  "4jU7ke": "Запустить проигрыватель контента",
  "4nG/GN": "Название контента",
  "5RR9aM": "Пауза для пакета",
  "5XSNyG": "Материалы успешно загружены",
  "6K/a0B": "Пауза",
  "6wAcmz": "Выберите время",
  "7M1nFY": "Вы подтверждаете удаление? Шаблон {name}?",
  "7OW60G": "Очистить выбранное время",
  "7Ouq4k": "Порядок: {sort}",
  "7cAtfM": "Время",
  "7wofGo": "Приложение",
  "9c8SPP": "Размер",
  BhWZJo: "Название ресурса",
  C55Kjj: "Воспроизводимый контент",
  "D+32Ow": "Центр управления ресурсами",
  EBMdAL: "Создано успешно",
  ECm6hH: "Вы уверены, что хотите удалить этот ресурс ({name})?",
  "ELFG/t": "Поиск устройства",
  IP9Kbk: "Размер изображений не может превышать 15 МБ",
  Ie9WHB: "Загрузить материал",
  KOVFgK: "Ожидает проверки",
  "Lqca+c": "Переключение проигрывателя",
  MDACCo: "Воспроизведение Успешно",
  MWJG8I: "Имя: {name}",
  "Ut8+i2": "Одобрено",
  "Xi/+KE": "Добавить временной интервал",
  YuZxve: "Выбрать контент",
  bKLb1C: "Воспроизвести",
  bYujGa: "Создать шаблон",
  fFaC3Z: "Время воспроизведения",
  gVXoXc: "Управление контентом",
  i9lOCU: "Выбранная вами дата начала раньше сегодняшней",
  iHQiQV: "Пакетное воспроизведение",
  iJIOBp: "Ошибка анализа",
  "iRR+fJ": "debugInfo",
  l9XE8F: "Пройдено",
  lchpP8: "Применение успешно выполнено",
  m8CFrl: "Создать новый шаблон",
  nbp4U6: "Список шаблонов контента",
  oUgWVb: "Тип: {type}",
  "p/EHrl": "Максимальный размер видео не может превышать 10 ГБ",
  qx5UwR: "Выберите устройство",
  rBWtYz: "Время последнего изменения",
  rnpMD3: "Выкл",
  sux9FA: "Введите нижний предел: 1",
  tRm3bw: "Пауза успешно поставлена",
  uhTa0i: "Предварительный просмотр",
  w1cMGO: "Дата окончания",
  ztKQno: "Длительность",
  J3dxzb:
    "В настоящее время Nubis поддерживает форматы изображений JPEG и PNG. Видео должно быть закодировано с использованием кодека H.264. Поддерживаемые форматы файлов включают MPEG-4 и MOV. Кодек — это программное или аппаратное обеспечение, которое сжимает данные для более быстрой передачи и восстанавливает исходный формат полученных данных. Кодек H.264 обычно используется для записи, сжатия и распространения видеоконтента. Формат видеофайла может содержать один или несколько кодеков. Если ваш видеофайл MOV или MPEG-4 не проходит проверку, убедитесь, что для кодирования видео используется кодек H.264.",
  "M5Vtr/": "Изменить шаблон",
  b1xi4S: "Предварительный просмотр шаблона",
  kNhfaL: "Вы уверены, что хотите удалить шаблон ({name})?",
  kqgd4D: "Добавить хотя бы одно время выполнения",
  "36pf2y": "История контента",
  "3izvEF": "Выбрать файл",
  "9mG+jv": "Размер файла превышает доступное место",
  AlFkwq: "Количество установленных устройств",
  C8ZuKU: "Ширина изображения",
  E0Czos: "Высота изображения",
  I73XLQ: "Ось Y изображения",
  JbroVc: "Nubis Cast",
  MMqJtu: "Необходимо выбрать изображение или видео",
  "Pv/1oy": "Отображение контента",
  Rrwy85: "Автор",
  T8Y38H: "Файл изображения (*.jpg/*.png)",
  VJ7wHx: "Количество устанавливаемых устройств",
  WI3Hl5: "Ось Y видео",
  "Y2Wh/g": "Видеофайл (*.mp4/*.mov)",
  "YLvNj+": "Подлежит развертыванию",
  kUbrNT:
    "Сначала загрузите файл в Центр управления ресурсами. В качестве шаблонов можно использовать только одобренные файлы.",
  n997QX: "Высота видео",
  rBD8kj: "Горизонтальная ось изображения",
  uCmncQ: "Ширина видео",
  QwmhEP: "История контента",
  "8vC+0s": "Необходимо выбрать воспроизводимый контент",
  "jG/AFY": "После подтверждения устройство применит новую конфигурацию, и её нельзя будет изменить в течение одного дня. Вы уверены, что хотите её применить?",
  "AxZAkZ": "Цифровой контент, загруженный на эту платформу, будет автоматически проверяться службой модерации контента Amazon Rekognition, чтобы снизить риск публикации в открытом доступе. Если автоматическая проверка не пройдёт, вы можете проверить его вручную; однако в этом случае платформа не будет нести ответственности за любые последующие последствия",
  "Oyd/7c": "Ручное одобрение",
  "wyHcKZ": "Напоминание об одобрении",
  "32HMy/": "Версия трансляции {nubis}",
  "IS73A4": "Время начала не может быть больше времени окончания",
  "jCAPQ2": "Режим трансляции {nubis}",
  "sWmzFs": "Время последнего обновления {ora}",
  "sctjLN": "Время последнего онлайн-обновления {ora}",
  "uoBkfP": "Статус последнего обновления {ora}",
  "3yichR": "Время последнего изменения",
  "d+otpZ": "Версия выпуска",
  "k30s+D": "Время последнего выпуска",
  "9bgunT": "Если эта опция отключена, вы можете вручную загрузить и установить последнюю версию {ora} или обновить её вручную с помощью команды устройства — {ora} update.",
  "Yh8vRi": "Если эта опция включена, она будет автоматически загружать и обновляться при появлении новой версии {ora}.",
  "ZO2gEn": "{nubis} version",
  "r+yR7v": "{nubis} Cast",
  "uf58G7": "Если автоматическое обновление отключено, различия в версии {ora} на устройстве могут привести к недоступности некоторых функций.",
  "y98D3X": "Вертикальная ось видео"
};
